// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed {
  max-width: 600px;
  margin: auto;
  padding: 20px;
}

/* CREATE POST */
.create-post {
  background: white;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.create-post img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.create-post textarea {
  flex: 1 1;
  border: none;
  resize: none;
  outline: none;
  background: #f0f2f5;
  border-radius: 20px;
  padding: 10px 15px;
  font-size: 16px;
}

.error-video {
  margin-top: 0 !important;
}

.create-post button {
  background: var(--primary-200);
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}

/* POST */
.post {
  position: relative;
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
}

.post-header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.post-header img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.post-header span {
  font-size: 12px;
  color: #777;
}

.post-text {
  margin: 10px 0;
}

.post-image {
  width: 100%;
  border-radius: 10px;
  margin-top: 10px;
}

.post-link {
  display: block;
  margin-top: 10px;
  color: #1877f2;
}

/* STATS */
.post-stats {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #555;
  margin-top: 10px;
}

/* ACTIONS */
.post-actions {
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #eee;
  margin-top: 10px;
  padding-top: 8px;
}

.post-actions button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 6px;
  align-items: center;
  color: #555;
}

.post-actions button.active {
  color: var(--primary-200);
}



/* OPTIONS */
.post-options {
  display: flex;
  justify-content: space-between;
  background: white;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.post-options button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1 1;
  margin: 0 5px;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background: #f0f2f5;
  cursor: pointer;
  font-weight: 500;
  transition: 0.3s;
  color: var(--primary-200);
}

.post-options button:hover {
  background: var(--primary-200);
  color: white;
}

/* MODAL */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  width: 360px;
  padding: 20px;
  border-radius: 12px;
  animation: scaleIn 0.2s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal h3 {
  margin-bottom: 15px;
}

.modal input,
.modal textarea {
  width: 100%;
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
  outline: none;
  font-size: 16px;
}

.modal textarea {
  min-height: 100px;
  resize: none;
}

/* ACTIONS */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-actions .cancel {
  background: #eee;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.modal-actions .publish {
  background: var(--primary-200);
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}


/* IMAGE UPLOAD */
.image-upload {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  border: 2px dashed #ccc;
  cursor: pointer;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 12px;
  transition: 0.3s;

  background: #fafafa;
  transition: 0.2s;
}

.post-text-wrapper{
  margin:12px 15px;
}



.image-upload:hover {
  border-color: var(--primary-200);
  background: #f5f8ff;
}

.image-upload img {
  width: 100%;
  /* height: 100%; */
  object-fit: cover;
}

.image-placeholder {
  text-align: center;
  color: #777;
}

.image-placeholder .camera {
  font-size: 36px;
  display: block;
}


/* responsive mobile */

@media (max-width: 768px) {
  .feed {
    max-width: 100%;
    padding: 12px;
    padding-bottom: 80px;
    /* navbar bottom */
  }
}

@media (max-width: 768px) {
  .create-post {
    padding: 12px;
    gap: 8px;
  }

  .create-post img {
    width: 40px;
    height: 40px;
  }

  .create-post textarea {
    font-size: 16px;
  }

  .create-post button {
    padding: 6px 10px;
    font-size: 14px;
  }
}


@media (max-width: 768px) {
  .post-actions button {
    font-size: 14px;
    padding: 8px 0;
  }
}

@media (max-width: 768px) {
  .post-options {
    gap: 6px;
  }

  .post-options button {
    padding: 8px;
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .image-upload {
    /* height: 150px; */
  }

  .image-placeholder .camera {
    font-size: 28px;
  }
}


/* Loading spinner */

.feed-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--bg-200);
  border-top: 4px solid var(--primary-100);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


/* .comment-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background: rgba(0,0,0,0.2);
  display: flex;
  align-items: flex-end;
  z-index: 50;
} */

.comment-overlay {
  position: fixed;
  inset: 0;
  /* background: rgba(0, 0, 0, 0.4); */
  display: flex;
  align-items: flex-end;
  max-width: 600px;
  margin: auto;
  z-index: 9999;
  /* height: 40%; */
}


/* .comment-panel {
  background: white;
  width: 100%;
  height: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  flex-direction: column;
} */


.comment-panel {
  background: white;
  width: 100%;
  height: 50%;
  max-height: 50%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.25s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}


.comment-header {
  padding: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.close-comments-btn {
  width: 38px;
  height: 38px;

  border: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: rgba(255, 255, 255, .08);

  color: var(--text-100);

  font-size: 20px;

  transition: .25s ease;
}

.close-comments-btn:hover {
  transform: rotate(90deg);
  background: rgba(255, 255, 255, .15);
}

.comment-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}

.comment-item {
  margin-bottom: 8px;
}

.comment-input {
  display: flex;
  padding: 8px;
  border-top: 1px solid #eee;
}

.comment-input input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 6px;
  font-size: 16px;
}

.comment-input button {
  background: var(--primary-200);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
}

.comment-top {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.comment-date {
  color: #888;
  font-size: 11px;
}

.delete-comment {
  background: none;
  border: none;
  color: var(--primary-100);
  font-size: 11px;
  cursor: pointer;
  padding: 0;
}


.pinned {
  background: #fff8e1;
  border-left: 3px solid var(--primary-100);
}

.pin-comment {
  background: none;
  border: none;
  color: var(--primary-200);
  font-size: 11px;
  cursor: pointer;
  margin-left: 10px;
}

.pin-badge {
  font-size: 11px;
  color: var(--primary-100);
  margin-left: 6px;
}

.pinned {
  animation: pinFlash 1.2s ease;
  background: #fff8e1;
}

@keyframes pinFlash {
  0% {
    background: #ffe082;
  }

  100% {
    background: #fff8e1;
  }
}

.comment-item {
  padding: 10px 0;
}

.comment-item:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}



/* .comment-header::before {
  content: "";
  width: 40px;
  height: 4px;
  background: #ccc;
  border-radius: 4px;
  display: block;
  margin: 0 auto 8px;
} */


.post-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.post-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.post-user-info {
  display: flex;
  align-items: center;
  gap: 5px;
}

.post-user-info span {
  font-size: 12px;
  color: var(--text-200);
}

.post-menu-dropdown {
  position: absolute;
  right: 0;
  top: 28px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  /* padding: 6px 0; */
  min-width: 160px;
  z-index: 20;
  animation: fadeInMenu 0.15s ease;
  margin-top: 20px;
  margin-right: 10px;

}

.post-menu-dropdown button {
  width: 100%;
  background: none;
  border: none;
  padding: 10px 16px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: var(--primary-100);
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s ease;
}

.post-menu-dropdown button:hover {
  background: rgba(233, 90, 19, 0.08);
}

@keyframes fadeInMenu {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


/* .zoom-control {
  margin-top: 10px;
}

.zoom-control label {
  font-size: 13px;
  color: #555;
}

.zoom-control input {
  width: 100%;
} */



/* Skelton post */

.skeleton-post .avatar {
  width: 40px;
  /* height: 40px; */
  border-radius: 50%;
}

.skeleton-post .name {
  width: 120px;
  height: 14px;
  margin-bottom: 6px;
}

.skeleton-post .date {
  width: 80px;
  height: 12px;
}

.skeleton-post .text {
  height: 16px;
  margin: 12px 0;
}

.skeleton-post .image {
  height: 260px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.skeleton-post .btn {
  height: 28px;
  width: 80px;
  margin-right: 10px;
}



/* skelton style */

.skeleton {
  background: #eaf0f4;
  animation: skeleton-loading 1.2s ease-in-out infinite alternate;
  border-radius: 6px;
}

@keyframes skeleton-loading {
  from { opacity: .58; }
  to { opacity: 1; }
}


.create-post .avatar {
  width: 40px;
  /* height: 40px; */
  border-radius: 50%;
}


.comment-skeleton {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.comment-skeleton .avatar {
  /* width: 28px; */
  /* height: 28px; */
  border-radius: 50%;
}

.comment-skeleton .text {
  flex: 1 1;
  height: 14px;
}

.no-comments {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}

.post-video-container {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  background: black;
}

.post-video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.edit-post-modal {
  max-width: 500px;
}

.edit-preview-image {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 12px;
}

.edit-preview-video {
  width: 100%;
  aspect-ratio: 1/1;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 12px;
}

.edit-preview-video video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.edit-textarea {
  width: 100%;
  /* min-height: 80px; */
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  resize: none;
}




/* comments */

.comment-main {
  display: flex;
  justify-content: space-between;
}

.comment-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
}

.comment-actions {
  display: flex;
  gap: 10px;
  font-size: 12px;
}

.comment-reply {
  margin-left: 30px;
  border-left: 2px solid #eee;
  padding-left: 10px;
}

.reply-box {
  margin-top: 5px;
  display: flex;
  gap: 5px;
}

.comment-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
}

/* LEFT */
.comment-left {
  flex: 1 1;
}

.comment-top {
  display: flex;
  align-items: center;
  gap: 6px;
}

.comment-bottom-actions {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}

/* RIGHT (LIKE) */
.comment-like-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 40px;
}

.like-comment {
  background: none;
  border: none;
  cursor: pointer;
  color: #888;
  transition: 0.2s;
}

.like-comment:hover {
  transform: scale(1.2);
}

.like-comment.liked {
  color: var(--primary-100);
}

.like-count {
  font-size: 12px;
  color: #666;
}

.edit-comment-box {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.edit-comment-box input {
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
}

.edit-actions {
  display: flex;
  gap: 8px;
}

.edit-comment {
  color: #1877f2;
  cursor: pointer;
  background: none;
  border: none;
}


.edit-actions {
  display: flex;
  gap: 10px;
  margin-top: 6px;
}

/* BASE */
.edit-actions button {
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s ease;
}

/* CANCEL */
.edit-actions button:first-child {
  background: transparent;
  color: #666;
  border: 1px solid #ddd;
}

/* .edit-actions button:first-child:hover {
  background: #f5f5f5;
  color: #000;
  transform: scale(1.05);
} */

/* SAVE (🔥 WOW BUTTON) */
.edit-actions button:last-child {
  background: var(--primary-100);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

/* HOVER */
.edit-actions button:last-child:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.5);
}

/* CLICK EFFECT */
.edit-actions button:active {
  transform: scale(0.95);
}


/* REPLY BUTTON */
.reply-comment {
  background: none;
  border: none;
  color: var(--primary-100);
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.reply-comment:hover {
  transform: scale(1.05);
}

/* INPUT REPLY */
.reply-box {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reply-box input {
  padding: 8px;
  border-radius: 20px;
  border: 1px solid #ddd;
  outline: none;
  font-size: 16px;
}

/* ACTIONS */
.reply-actions {
  display: flex;
  gap: 8px;
}

.reply-actions button {
  border-radius: 20px;
  padding: 5px 12px;
  border: none;
  cursor: pointer;
  font-size: 12px;
}

.reply-actions button:first-child {
  background: #f1f1f1;
}

.reply-actions button:last-child {
  background: var(--primary-100);
  color: white;
}

/* REPLIES CONTAINER */
.replies-container {
  margin-top: 10px;
  padding-left: 12px;
  border-left: 2px solid #eee;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* SINGLE REPLY */


.reply-item {
  /* background: #f7f9fc; */
  /* padding: 8px 10px; */
  border-radius: 10px;
  transition: 0.2s;
}



.reply-content {
  display: flex;
  gap: 6px;
  font-size: 13px;
}

.reply-date {
  color: #888;
  font-size: 11px;
}

/* ANIMATION */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.show-more-replies,
.hide-replies {
  font-size: 12px;
  color: var(--primary-100);
  cursor: pointer;
  margin-top: 4px;
  display: inline-block;
  font-weight: 600;
  transition: 0.2s;
}

.show-more-replies:hover,
.hide-replies:hover {
  text-decoration: underline;
  transform: translateX(2px);
}


/* MENTION */
.mention {
  color: var(--primary-100);
  font-weight: 700;
  margin-right: 4px;
}

/* ACTIONS REPLY */
.reply-actions-row {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.reply-actions-row button {
  background: none;
  border: none;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: 0.2s;
}

.reply-actions-row button:hover {
  color: var(--primary-100);
  transform: translateX(2px);
}


.reply-item {
  position: relative;
}

.reply-item .comment-like-section {
  position: absolute;
  right: 5px;
  top: 5px;
}


.clickable-username {
  cursor: pointer;
  transition: 0.2s;
}

.clickable-username:hover {
  color: var(--primary-200);
}

.post-menu-dropdown .edit_btn_drop {
  color: var(--primary-200);
}

.post-menu-icon {
  cursor: pointer;
}

.post-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.follow-btn-post {
  background: var(--primary-200);
  color: white;
  border: none;
  padding: 5px 30px;
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
}

.following-temp {
  background: var(--bg-200);
  color: white;
  border: 1px var(--primary-200);
  padding: 5px 30px;
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
}


.send-post-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(10, 10, 10, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.25s ease;
}

.send-post-share-modal {
  width: 420px;
  max-height: 80vh;
  background: white;
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 20px;
  /* color: white; */
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  animation: scaleIn 0.25s ease;
  display: flex;
  flex-direction: column;
}

.send-post-share-modal h3 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
}

.send-post-share-list {
  overflow-y: auto;
  max-height: 300px;
  padding-right: 5px;
}

/* scrollbar clean */
.send-post-share-list::-webkit-scrollbar {
  width: 5px;
}

.send-post-share-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

.send-post-share-item {
  padding: 10px;
  border-radius: 12px;
  transition: 0.2s;
  cursor: pointer;
}

.send-post-share-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.send-post-share-item input[type="checkbox"] {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 2px solid #555;
  margin-right: 10px;
  cursor: pointer;
  position: relative;
  transition: 0.2s;
}

.send-post-share-item input[type="checkbox"]:checked {
  /* background: linear-gradient(135deg, #4facfe, #00f2fe); */
  background: var(--primary-200);
  border: none;
}

.send-post-share-item input[type="checkbox"]:checked::after {
  content: "✓";
  color: white;
  font-size: 12px;
  position: absolute;
  top: 1px;
  left: 4px;
}

.send-post-share-item label {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.send-post-modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  gap: 10px;
}

.send-post-modal-actions button:first-child {
  flex: 1 1;
  background: transparent;
  border: 1px solid #555;
  color: var(--primary-200);
  font-weight: bold;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.send-post-modal-actions button:first-child:hover {
  background: rgba(255, 255, 255, 0.1);
}

.send-post-modal-actions button:last-child {
  flex: 1 1;
  /* background: linear-gradient(135deg, #4facfe, #00f2fe); */
  background: var(--primary-200);
  border: none;
  color: white;
  font-weight: bold;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.25s;
}

.send-post-modal-actions button:last-child:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 242, 254, 0.4);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}





.publish-loading-bar {

  position: fixed;

  top: 0;
  left: 0;

  width: 100%;
  height: 4px;

  z-index: 99999;

  background: #e5e7eb;

}

.publish-progress {

  height: 100%;

  width: 40%;

  background: #4e7799;

  animation:
    loadingMove 1.2s linear infinite;

}

.publish-loading-bar span {

  position: fixed;

  top: 15px;

  left: 50%;

  transform:
    translateX(-50%);

  background: white;

  padding: 10px 18px;

  border-radius: 999px;

  font-size: 14px;

  font-weight: 600;

  box-shadow:
    0 8px 30px rgba(0, 0, 0, .1);

}

@keyframes loadingMove {

  0% {

    transform:
      translateX(-100%);

  }

  100% {

    transform:
      translateX(300%);

  }

}


.publish-toast {

  position: fixed;

  bottom: 30px;
  left: 50%;

  transform:
    translateX(-50%);

  background: white;

  padding: 14px 20px;

  border-radius: 18px;

  display: flex;

  align-items: center;

  gap: 15px;

  box-shadow:
    0 10px 30px rgba(0, 0, 0, .15);

  z-index: 99999;

  animation:
    toastUp .35s ease;

}

.publish-success-icon {

  width: 45px;
  height: 45px;

  border-radius: 50%;

  display: flex;

  align-items: center;
  justify-content: center;

  background: #22c55e;

  color: white;

  font-size: 20px;

  font-weight: bold;

}

@keyframes toastUp {

  from {

    opacity: 0;

    transform:
      translate(-50%,
        30px);

  }

  to {

    opacity: 1;

    transform:
      translate(-50%,
        0);

  }

}


.post-text{

  white-space:pre-wrap;
  word-break:break-word;
  line-height:1.5;
  margin:0;

}

.post-text.collapsed{

  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:3;

  overflow:hidden;

}

.post-text.expanded{

  display:block;

}

.post-see-more{

  margin-top:8px;

  border:none;
  background:none;

  color:var(--primary-100);

  font-weight:600;

  cursor:pointer;

  padding:0;

}



/* 
.post.modal-layout{
  display:flex;
  width:100%;
  height:88vh;
  max-width:1400px;
  background:#fff;
  border-radius:22px;
  overflow:hidden;
}



.post-left-side .post-image,
.post-left-side .post-video-container{
  flex:1;
  width:100%;
  min-height:0;
  background:black;
}

.post-left-side img,
.post-left-side video{
  width:100%;
  height:100%;
  object-fit:contain;
}


.post-right-side{
  width:40%;
  border-left:1px solid #eee;
  display:flex;
  flex-direction:column;
  background:white;
}



.comment-panel{
  position:relative !important;
  inset:auto !important;
  width:100% !important;
  height:100%;
  border-radius:0;
  box-shadow:none;
}



.comment-list{
  flex:1;
  overflow-y:auto;
}


.comment-input{
  position:sticky;
  bottom:0;
  background:white;
  border-top:1px solid #eee;
} */



.share-success-toast {

  position: fixed;

  bottom: 30px;
  left: 50%;

  transform: translateX(-50%);

  display: flex;
  align-items: center;
  gap: 12px;

  background: white;

  padding: 14px 20px;

  border-radius: 18px;

  box-shadow:
    0 10px 35px rgba(0, 0, 0, .15);

  animation:
    sharePopup .35s ease;

  z-index: 999999;

}

.share-success-icon {

  width: 42px;
  height: 42px;

  border-radius: 50%;

  background: var(--primary-100);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;

  font-weight: bold;
  font-size: 18px;

}

.share-success-toast strong {

  display: block;
  font-size: 14px;

}

.share-success-toast p {

  margin: 2px 0 0;
  color: #777;
  font-size: 12px;

}

@keyframes sharePopup {

  from {

    opacity: 0;

    transform:
      translate(-50%, 30px);

  }

  to {

    opacity: 1;

    transform:
      translate(-50%, 0);

  }

}


/* .post-user-icon{
  color: var(--primary-200);
} */

/* Premium CarrerUp composer */
.create-post {
  position: relative;
  align-items: center;
  padding: 14px;
  overflow: hidden;
  background: rgba(250, 252, 253, .94);
  border: 1px solid rgba(78, 119, 153, .17);
  border-radius: 17px;
  box-shadow: 0 14px 32px rgba(30, 63, 88, .09), inset 0 1px rgba(255, 255, 255, .95);
}

.create-post::before {
  content: "";
  position: absolute;
  top: 0;
  right: 22px;
  left: 22px;
  height: 1px;
  background: rgba(233, 90, 19, .33);
}

.create-post img,
.create-post > .post-user-icon,
.create-post > .avatar {
  flex: 0 0 auto;
  box-sizing: border-box;
  width: 43px !important;
  height: 43px !important;
  padding: 2px;
  border: 2px solid #fff;
  border-radius: 13px !important;
  color: #4e7799;
  background: #eaf0f4;
  box-shadow: 0 4px 12px rgba(30, 63, 88, .12);
}

.create-post textarea {
  min-height: 46px;
  padding: 12px 14px;
  border: 1px solid transparent;
  border-radius: 13px;
  color: #29475e;
  background: #eef3f6;
  font-size: .88rem;
  line-height: 1.35;
  transition: .2s ease;
}

.create-post textarea::placeholder { color: #71899b; }

.create-post textarea:focus {
  border-color: rgba(233, 90, 19, .5);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .08);
}

.create-post button {
  min-height: 43px;
  padding: 0 15px;
  border: 1px solid #e95a13;
  border-radius: 12px;
  background: #e95a13;
  box-shadow: 0 8px 18px rgba(233, 90, 19, .2);
  font-size: .78rem;
  font-weight: 750;
  transition: .2s ease;
}

.create-post button:hover {
  background: #d84f0d;
  box-shadow: 0 11px 21px rgba(233, 90, 19, .28);
  transform: translateY(-1px);
}

.post-options {
  position: relative;
  gap: 9px;
  padding: 10px;
  overflow: hidden;
  background: rgba(250, 252, 253, .94);
  border: 1px solid rgba(78, 119, 153, .15);
  border-radius: 16px;
  box-shadow: 0 12px 26px rgba(30, 63, 88, .07), inset 0 1px rgba(255, 255, 255, .92);
}

.post-options::before {
  content: "";
  position: absolute;
  top: 0;
  right: 28px;
  left: 28px;
  height: 1px;
  background: rgba(78, 119, 153, .22);
}

.post-options button {
  flex: 1 1;
  justify-content: center;
  gap: 7px;
  min-height: 42px;
  margin: 0;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #4e7799;
  background: #edf3f6;
  cursor: pointer;
  font-size: .78rem;
  font-weight: 700;
  transition: .2s ease;
}

.post-options button svg {
  font-size: .95rem;
  color: #4e7799;
  transition: .2s ease;
}

.post-options button:hover {
  border-color: rgba(233, 90, 19, .22);
  color: #d84f0d;
  background: #fff3ec;
  box-shadow: 0 5px 13px rgba(30, 63, 88, .08);
  transform: translateY(-2px);
}

.post-options button:hover svg { color: #e95a13; }

@media (max-width: 944px) {
  .create-post {
    margin-bottom: 14px;
    padding: 11px;
    gap: 8px;
  }

  .create-post img,
  .create-post > .post-user-icon,
  .create-post > .avatar {
    width: 39px !important;
    height: 39px !important;
  }

  .create-post textarea {
    min-width: 0;
    padding: 10px 11px;
    font-size: .8rem;
  }

  .create-post button {
    padding: 0 11px;
    font-size: .72rem;
  }

  .post-options {
    gap: 6px;
    padding: 8px;
    margin-bottom: 14px;
  }

  .post-options button {
    flex-direction: column;
    gap: 3px;
    min-height: 48px;
    padding: 6px 4px;
    font-size: .67rem;
  }
}

/* Feed canvas — step 1: application surface and responsive reading column. */
.dashboard-main.feed-canvas {
  box-sizing: border-box;
  padding: 92px 24px 48px !important;
  background: #f4f7f8;
}

.feed-canvas .feed {
  box-sizing: border-box;
  width: min(100%, 680px);
  max-width: 680px;
  margin: 0 auto;
  padding: 0;
}

@media (max-width: 944px) {
  .dashboard-main.feed-canvas {
    padding: 86px 16px 96px !important;
  }

  .feed-canvas .feed {
    width: min(100%, 640px);
    max-width: 640px;
  }
}

@media (max-width: 768px) {
  .dashboard-main.feed-canvas {
    padding: 86px 12px 96px !important;
  }

  .feed-canvas .feed {
    width: 100%;
    max-width: none;
    padding: 0;
  }
}

/* Feed composer: one unified entry point above the publication stream. */
.feed-composer {
  position: relative;
  margin-bottom: 26px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(78, 119, 153, .18);
  border-radius: 20px;
  box-shadow: 0 16px 34px rgba(30, 63, 88, .09), inset 0 1px #ffffff;
}

.feed-composer::before {
  content: "";
  position: absolute;
  top: 0;
  right: 28px;
  left: 28px;
  height: 2px;
  background: #e95a13;
}

.feed-composer .create-post {
  margin: 0;
  padding: 17px;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.feed-composer .create-post::before,
.feed-composer .post-options::before {
  display: none;
}

.feed-composer .post-options {
  margin: 0;
  padding: 10px 12px 12px;
  background: transparent;
  border: 0;
  border-top: 1px solid rgba(78, 119, 153, .13);
  border-radius: 0;
  box-shadow: none;
}

.feed-composer .post-options button {
  min-height: 44px;
  background: #f1f5f7;
}

.feed-composer .post-options button:hover {
  background: #fff3ec;
}

@media (max-width: 944px) {
  .feed-composer {
    margin-bottom: 20px;
    border-radius: 18px;
  }

  .feed-composer .create-post {
    margin: 0;
    padding: 12px;
  }

  .feed-composer .post-options {
    margin: 0;
    padding: 8px 10px 10px;
  }
}

@media (max-width: 768px) {
  .feed-composer {
    margin-bottom: 18px;
    border-radius: 16px;
  }

  .feed-composer::before {
    right: 20px;
    left: 20px;
  }

  .feed-composer .create-post {
    padding: 11px;
  }

  .feed-composer .post-options {
    padding: 8px;
  }
}

/* Publication cards: clear hierarchy inspired by the validated feed direction. */
.feed-canvas .post {
  overflow: visible;
  margin-bottom: 18px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 18px;
  box-shadow: 0 10px 26px rgba(30, 63, 88, .06), inset 0 1px #ffffff;
}

.feed-canvas .post-header {
  min-height: 48px;
  gap: 14px;
}

.feed-canvas .post-header-left {
  min-width: 0;
  gap: 11px;
}

.feed-canvas .post-header img,
.feed-canvas .post-header .post-user-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  box-sizing: border-box;
  width: 46px;
  height: 46px;
  padding: 2px;
  object-fit: cover;
  border: 2px solid #ffffff;
  border-radius: 50%;
  color: #4e7799;
  background: #eaf0f4;
  box-shadow: 0 4px 12px rgba(30, 63, 88, .12);
}

.feed-canvas .post-user-info {
  min-width: 0;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.feed-canvas .post-user-info b {
  overflow: hidden;
  max-width: 100%;
  color: #1d394f;
  font-size: .94rem;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feed-canvas .post-header-right {
  margin-left: auto;
  gap: 10px;
}

.feed-canvas .post-time {
  display: inline-block;
  color: #71899b;
  font-size: .75rem;
  font-weight: 650;
  white-space: nowrap;
}

.feed-canvas .post-menu-icon {
  box-sizing: content-box;
  padding: 8px;
  border-radius: 10px;
  color: #4e7799;
  transition: .18s ease;
}

.feed-canvas .post-menu-icon:hover {
  color: #e95a13;
  background: #fff3ec;
}

.feed-canvas .follow-btn-post,
.feed-canvas .following-temp {
  padding: 7px 13px;
  border-radius: 10px;
  font-size: .72rem;
  font-weight: 750;
}

.feed-canvas .follow-btn-post {
  border: 1px solid rgba(233, 90, 19, .22);
  color: #d84f0d;
  background: #fff3ec;
}

.feed-canvas .post-text-wrapper {
  margin: 16px 0 0;
}

.feed-canvas .post-text {
  color: #345269;
  font-size: .9rem;
  line-height: 1.65;
}

.feed-canvas .post-see-more {
  color: #e95a13;
  font-size: .8rem;
}

.feed-canvas .post-image {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 5;
  max-height: 520px;
  margin-top: 16px;
  object-fit: cover;
  background: #eef3f6;
  border: 1px solid rgba(78, 119, 153, .13);
  border-radius: 14px;
}

.feed-canvas .post-video-container {
  margin-top: 16px;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #020617;
  border: 1px solid rgba(78, 119, 153, .13);
  border-radius: 14px;
}

.feed-canvas .post-video-container video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.feed-infinite-sentinel {
  width: 100%;
  height: 1px;
  pointer-events: none;
}

.feed-canvas .post-link {
  margin-top: 16px;
  padding: 12px 14px;
  overflow: hidden;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 12px;
  color: #4e7799;
  background: #f4f8fa;
  font-size: .82rem;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feed-canvas .post-stats {
  justify-content: flex-start;
  gap: 16px;
  margin-top: 15px;
  padding: 0 3px 11px;
  border-bottom: 1px solid rgba(78, 119, 153, .13);
  color: #71899b;
  font-size: .75rem;
}

.feed-canvas .post-actions {
  position: relative;
  justify-content: flex-start;
  gap: 6px;
  margin-top: 18px;
  padding-top: 15px;
  border: 0;
}

.feed-canvas .post-actions::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 1px;
  background: rgba(78, 119, 153, .16);
}

.feed-canvas .post-actions::after {
  content: "";
  position: absolute;
  top: -1px;
  left: 0;
  width: 52px;
  height: 2px;
  border-radius: 2px;
  background: #e95a13;
}

.feed-canvas .post-actions button {
  flex: 0 0 auto;
  justify-content: center;
  min-width: 52px;
  min-height: 40px;
  border-radius: 10px;
  color: #4e7799;
  font-size: .78rem;
  font-weight: 700;
  transition: .18s ease;
}

.feed-canvas .post-actions button svg {
  font-size: 1rem;
}

.feed-canvas .post-action-count {
  min-width: 1ch;
  color: currentColor;
  font-size: .76rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.feed-canvas .post-actions button:hover {
  color: #d84f0d;
  background: #fff3ec;
}

.feed-canvas .post-actions button.active {
  color: #e95a13;
  /* background: #fff3ec; */
}

@media (max-width: 944px) {
  .feed-canvas .post {
    margin-bottom: 15px;
    padding: 14px;
    border-radius: 16px;
  }

  .feed-canvas .post-image,
  .feed-canvas .post-video-container {
    margin-top: 14px;
  }
}

@media (max-width: 768px) {
  .feed-canvas .post {
    margin-bottom: 14px;
    padding: 13px;
    border-radius: 15px;
  }

  .feed-canvas .post-header {
    gap: 9px;
  }

  .feed-canvas .post-header img,
  .feed-canvas .post-header .post-user-icon {
    width: 42px;
    height: 42px;
  }

  .feed-canvas .post-user-info b {
    font-size: .88rem;
  }

  .feed-canvas .post-time {
    font-size: .68rem;
  }

  .feed-canvas .follow-btn-post,
  .feed-canvas .following-temp {
    padding: 6px 9px;
    font-size: .66rem;
  }

  .feed-canvas .post-text-wrapper {
    margin-top: 13px;
  }

  .feed-canvas .post-text {
    font-size: .84rem;
    line-height: 1.55;
  }

  .feed-canvas .post-image,
  .feed-canvas .post-video-container {
    margin-top: 13px;
    border-radius: 12px;
  }

  .feed-canvas .post-stats {
    gap: 10px;
    margin-top: 13px;
    padding-bottom: 9px;
    font-size: .68rem;
  }

  .feed-canvas .post-actions {
    gap: 3px;
    margin-top: 15px;
    padding-top: 12px;
  }

  .feed-canvas .post-actions button {
    gap: 5px;
    min-height: 38px;
    padding: 6px 4px;
  }

  .feed-canvas .post-action-count {
    font-size: .7rem;
  }
}

/* Desktop feed panels: supplementary navigation stays outside the reading flow. */
.feed-layout {
  display: block;
}

.feed-sidebar {
  display: none;
}

.feed-mobile-sections {
  display: none;
}

@media (min-width: 1150px) {
  .feed-canvas .feed {
    width: min(100%, 1240px);
    max-width: 1240px;
  }

  .feed-layout {
    display: grid;
    grid-template-columns: 190px minmax(0, 680px) 250px;
    gap: 18px;
    align-items: start;
  }

  .feed-stream {
    grid-column: 2;
    min-width: 0;
  }

  .feed-sidebar {
    position: fixed;
    z-index: 10;
    top: 88px;
    align-self: start;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: calc(100vh - 104px);
    max-height: calc(100dvh - 104px);
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-width: thin;
    scrollbar-color: rgba(78, 119, 153, .3) transparent;
  }

  .feed-sidebar-left {
    left: max(24px, calc((100vw - 1240px) / 2));
    width: 190px;
  }

  .feed-sidebar-right {
    right: max(24px, calc((100vw - 1240px) / 2));
    width: 250px;
  }

  .feed-sidebar::-webkit-scrollbar {
    width: 5px;
  }

  .feed-sidebar::-webkit-scrollbar-thumb {
    background: rgba(78, 119, 153, .3);
    border-radius: 999px;
  }

  .feed-side-panel {
    padding: 14px;
    background: #ffffff;
    border: 1px solid rgba(78, 119, 153, .16);
    border-radius: 16px;
    box-shadow: 0 10px 24px rgba(30, 63, 88, .05), inset 0 1px #ffffff;
  }

  .feed-side-kicker {
    margin: 0 0 10px;
    color: #345269;
    font-size: .75rem;
    font-weight: 800;
    letter-spacing: .06em;
    text-transform: uppercase;
  }

  .feed-career-pulse-panel {
    position: relative;
    overflow: hidden;
    padding: 16px 14px 14px;
  }

  .feed-career-pulse-panel::before {
    content: "";
    position: absolute;
    top: 0;
    right: 18px;
    left: 18px;
    height: 2px;
    background: #e95a13;
  }

  .feed-pulse-heading {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 13px;
  }

  .feed-pulse-icon,
  .feed-pulse-metric-icon {
    display: grid;
    flex: 0 0 auto;
    place-items: center;
    color: #e95a13;
    background: #fff2ea;
    border: 1px solid #ffd7c2;
  }

  .feed-pulse-icon {
    width: 31px;
    height: 31px;
    border-radius: 10px;
    font-size: .85rem;
  }

  .feed-pulse-heading .feed-side-kicker {
    margin: 0 0 2px;
  }

  .feed-pulse-heading small {
    color: #71899b;
    font-size: .65rem;
    font-weight: 650;
  }

  .feed-pulse-metric {
    display: grid;
    grid-template-columns: 25px minmax(0, 1fr);
    gap: 8px;
    align-items: center;
    padding: 9px 0;
    border-top: 1px solid rgba(78, 119, 153, .11);
  }

  .feed-pulse-metric-icon {
    width: 25px;
    height: 25px;
    border-radius: 8px;
    color: #4e7799;
    background: #eef4f7;
    border-color: #dce8ee;
    font-size: .7rem;
  }

  .feed-pulse-metric small,
  .feed-pulse-metric strong,
  .feed-pulse-metric em {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .feed-pulse-metric small {
    margin-bottom: 2px;
    color: #71899b;
    font-size: .63rem;
    font-weight: 650;
  }

  .feed-pulse-metric strong {
    color: #29475e;
    font-size: .7rem;
    font-weight: 800;
  }

  .feed-pulse-metric em {
    margin-top: 2px;
    color: #4e7799;
    font-size: .62rem;
    font-style: normal;
    font-weight: 650;
  }

  .feed-pulse-opportunity .feed-pulse-metric-icon {
    color: #e95a13;
    background: #fff7f2;
    border-color: #ffd9c5;
  }

  .feed-pulse-progress {
    margin-top: 4px;
    padding-top: 11px;
    border-top: 1px solid rgba(78, 119, 153, .13);
  }

  .feed-pulse-progress-label {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 7px;
    color: #71899b;
    font-size: .65rem;
    font-weight: 700;
  }

  .feed-pulse-progress-label strong { color: #e95a13; font-size: .7rem; }

  .feed-pulse-progress-track {
    display: block;
    height: 5px;
    overflow: hidden;
    background: #eaf0f3;
    border-radius: 999px;
  }

  .feed-pulse-progress-track span {
    display: block;
    height: 100%;
    min-width: 5px;
    background: #e95a13;
    border-radius: inherit;
    transition: width .35s ease;
  }

  .feed-quick-link {
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) 14px;
    align-items: center;
    width: 100%;
    min-height: 42px;
    padding: 8px 7px;
    border: 0;
    border-radius: 10px;
    color: #345269;
    background: transparent;
    cursor: pointer;
    font-size: .78rem;
    font-weight: 700;
    text-align: left;
    transition: .18s ease;
  }

  .feed-quick-link > svg:first-child {
    color: #4e7799;
    font-size: .94rem;
  }

  .feed-quick-link > svg:last-child {
    color: #94a9ba;
    font-size: .65rem;
  }

  .feed-quick-link:hover {
    color: #d84f0d;
    background: #fff3ec;
  }

  .feed-quick-link:hover > svg:first-child,
  .feed-quick-link:hover > svg:last-child {
    color: #e95a13;
  }

  .feed-suggestions-panel .suggested-card {
    gap: 8px;
    margin: 0;
    padding: 10px 0;
    border: 0;
    border-bottom: 1px solid rgba(78, 119, 153, .12);
    border-radius: 0;
    box-shadow: none;
  }

  .feed-suggestions-panel .suggested-card:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  .feed-suggestions-panel .suggested-card:hover {
    transform: none;
    box-shadow: none;
  }

  .feed-suggestions-panel .suggested-header {
    display: none;
  }

  .feed-suggestions-panel .suggested-body {
    gap: 9px;
  }

  .feed-suggestions-panel .avatar {
    /* width: 38px; */
    /* height: 38px; */
    border: 1px solid rgba(78, 119, 153, .15);
  }

  .feed-suggestions-panel .avatar-placeholder {
    color: #4e7799;
    background: #edf3f6;
    font-size: .85rem;
  }

  .feed-suggestions-panel .info h4 {
    color: #29475e;
    font-size: .75rem;
  }

  .feed-suggestions-panel .info p {
    overflow: hidden;
    margin: 1px 0;
    color: #71899b;
    font-size: .66rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .feed-suggestions-panel .suggested-actions {
    gap: 6px;
    margin-top: 0;
  }

  .feed-suggestions-panel .suggested-actions button {
    min-height: 30px;
    padding: 5px 6px;
    border: 1px solid rgba(78, 119, 153, .13);
    border-radius: 8px;
    font-size: .62rem;
  }

  .feed-suggestions-panel .suggested-actions .like {
    color: #d84f0d;
    background: #fff3ec;
  }

  .feed-role-panel {
    position: relative;
    overflow: hidden;
    padding: 18px 14px 14px;
  }

  .feed-role-panel::before {
    content: "";
    position: absolute;
    top: 0;
    right: 22px;
    left: 22px;
    height: 2px;
    background: #e95a13;
  }

  .feed-role-icon {
    margin-bottom: 10px;
    padding: 9px;
    border-radius: 11px;
    color: #e95a13;
    background: #fff3ec;
    font-size: 1.15rem;
  }

  .feed-role-panel h3 {
    margin: 0 0 6px;
    color: #29475e;
    font-size: .9rem;
  }

  .feed-role-panel p {
    margin: 0 0 13px;
    color: #71899b;
    font-size: .72rem;
    line-height: 1.5;
  }

  .feed-role-panel button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 36px;
    padding: 8px 10px;
    border: 1px solid #e95a13;
    border-radius: 9px;
    color: #ffffff;
    background: #e95a13;
    cursor: pointer;
    font-size: .68rem;
    font-weight: 750;
    transition: .18s ease;
  }

  .feed-role-panel button:hover {
    background: #d84f0d;
    transform: translateY(-1px);
  }
}

@media (max-width: 944px) {
  .feed-mobile-sections {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0 0 16px;
  }

  .feed-mobile-role {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: 10px;
    padding: 12px;
    background: #ffffff;
    border: 1px solid rgba(78, 119, 153, .16);
    border-radius: 15px;
    box-shadow: 0 8px 20px rgba(30, 63, 88, .05);
  }

  .feed-mobile-role .feed-role-icon {
    margin: 0;
    padding: 8px;
    border-radius: 10px;
    color: #e95a13;
    background: #fff3ec;
    font-size: 1rem;
  }

  .feed-mobile-role h3 {
    margin: 0 0 2px;
    color: #29475e;
    font-size: .78rem;
  }

  .feed-mobile-role p {
    margin: 0;
    color: #71899b;
    font-size: .66rem;
    line-height: 1.35;
  }

  .feed-mobile-role button {
    display: flex;
    align-items: center;
    gap: 5px;
    min-height: 32px;
    padding: 6px 8px;
    border: 1px solid #e95a13;
    border-radius: 8px;
    color: #ffffff;
    background: #e95a13;
    cursor: pointer;
    font-size: .66rem;
    font-weight: 750;
  }

}

@media (min-width: 769px) and (max-width: 944px) {
  .feed-mobile-sections {
    margin-bottom: 20px;
  }

  .feed-mobile-role {
    padding: 14px 16px;
  }

  .feed-mobile-role h3 {
    font-size: .84rem;
  }

  .feed-mobile-role p {
    font-size: .72rem;
  }

  .feed-mobile-role button {
    min-height: 36px;
    padding: 7px 11px;
    font-size: .7rem;
  }

  .feed-canvas .post-actions button {
    min-height: 41px;
    padding: 7px 9px;
  }
}

/* Final interaction polish. */
.feed-canvas button:focus-visible,
.feed-canvas a:focus-visible {
  outline: 2px solid #e95a13;
  outline-offset: 2px;
}

.feed-mobile-role button {
  transition: .18s ease;
}

.feed-mobile-role button:hover {
  background: #d84f0d;
  transform: translateY(-1px);
}

@media (prefers-reduced-motion: reduce) {
  .feed-canvas *,
  .feed-canvas *::before,
  .feed-canvas *::after {
    scroll-behavior: auto !important;
    transition-duration: .01ms !important;
    animation-duration: .01ms !important;
    animation-iteration-count: 1 !important;
  }
}

/* Feed typography: a crisp, professional sports-network voice. */
.feed-canvas {
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #1d394f;
  letter-spacing: .003em;
}

.feed-canvas button,
.feed-canvas input,
.feed-canvas textarea {
  font-family: inherit;
}

.feed-canvas .create-post textarea {
  font-size: .92rem;
  font-weight: 500;
  letter-spacing: .005em;
}

.feed-canvas .create-post button,
.feed-canvas .post-options button,
.feed-canvas .feed-role-panel button,
.feed-canvas .feed-mobile-role button {
  letter-spacing: .015em;
  font-weight: 800;
}

.feed-canvas .post-user-info b {
  font-size: .98rem;
  /* font-weight: 800; */
  letter-spacing: -.012em;
}

.feed-canvas .post-time {
  font-size: .74rem;
  font-weight: 600;
  letter-spacing: .01em;
}

.feed-canvas .post-text {
  color: #29475e;
  font-size: .94rem;
  font-weight: 450;
  letter-spacing: .006em;
  line-height: 1.68;
}

.feed-canvas .post-link {
  font-weight: 700;
  letter-spacing: .01em;
}

.feed-canvas .post-action-count {
  font-size: .78rem;
  font-weight: 750;
}

.feed-canvas .feed-side-kicker {
  font-size: .7rem;
  font-weight: 850;
  letter-spacing: .09em;
}

.feed-canvas .feed-quick-link {
  font-size: .8rem;
  font-weight: 750;
  letter-spacing: .008em;
}

.feed-canvas .feed-role-panel h3,
.feed-canvas .feed-mobile-role h3 {
  font-weight: 850;
  letter-spacing: -.012em;
}

.feed-canvas .feed-role-panel p,
.feed-canvas .feed-mobile-role p {
  font-weight: 500;
  letter-spacing: .008em;
}

@media (max-width: 768px) {
  .feed-canvas .create-post textarea {
    font-size: .84rem;
  }

  .feed-canvas .post-user-info b {
    font-size: .91rem;
  }

  .feed-canvas .post-text {
    font-size: .87rem;
    line-height: 1.62;
  }
}

/* Post, video and link modals: bright high-tech CarrerUp treatment. */
.modal-overlay {
  padding: 20px;
  background: rgba(20, 43, 61, .48);
  backdrop-filter: blur(12px);
}

.modal-overlay > .modal {
  position: relative;
  box-sizing: border-box;
  width: min(100%, 470px);
  max-height: min(88vh, 720px);
  overflow-y: auto;
  padding: 24px;
  border: 1px solid rgba(148, 169, 186, .42);
  border-radius: 22px;
  color: #1d394f;
  background: #fbfcfd;
  box-shadow: 0 28px 75px rgba(12, 31, 47, .32), inset 0 1px #ffffff;
  animation: feed-modal-in .24s ease-out;
}

.modal-overlay > .modal::before {
  content: "";
  position: absolute;
  top: 0;
  right: 34px;
  left: 34px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #e95a13;
}

.modal-overlay > .modal h3 {
  margin: 4px 0 20px;
  color: #1d394f;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 1.1rem;
  font-weight: 850;
  letter-spacing: -.01em;
}

.modal-overlay > .modal input,
.modal-overlay > .modal textarea {
  box-sizing: border-box;
  margin-bottom: 14px;
  padding: 13px 14px;
  border: 1px solid rgba(78, 119, 153, .2);
  border-radius: 12px;
  color: #29475e;
  background: #f1f5f7;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .88rem;
  transition: .18s ease;
}

.modal-overlay > .modal input:focus,
.modal-overlay > .modal textarea:focus {
  border-color: #e95a13;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.modal-overlay > .modal .image-upload {
  margin-bottom: 16px;
  border: 1px dashed rgba(78, 119, 153, .42);
  border-radius: 14px;
  background: #f4f8fa;
}

.modal-overlay > .modal .image-upload:hover {
  border-color: #e95a13;
  background: #fff8f4;
}

.modal-overlay > .modal .image-placeholder {
  color: #4e7799;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .85rem;
  font-weight: 700;
}

.modal-overlay > .modal .image-placeholder .camera,
.modal-overlay > .modal .image-placeholder > svg {
  color: #e95a13;
}

.modal-overlay > .modal .modal-actions {
  gap: 9px;
  padding-top: 4px;
}

.modal-overlay > .modal .modal-actions button {
  min-height: 42px;
  padding: 9px 15px;
  border-radius: 11px;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .78rem;
  font-weight: 800;
  transition: .18s ease;
}

.modal-overlay > .modal .modal-actions .cancel {
  border: 1px solid rgba(78, 119, 153, .22);
  color: #4e7799;
  background: #f1f5f7;
}

.modal-overlay > .modal .modal-actions .cancel:hover {
  color: #29475e;
  background: #e6eef2;
}

.modal-overlay > .modal .modal-actions .publish {
  border: 1px solid #e95a13;
  background: #e95a13;
  box-shadow: 0 8px 18px rgba(233, 90, 19, .2);
}

.modal-overlay > .modal .modal-actions .publish:hover {
  background: #d84f0d;
  transform: translateY(-1px);
}

@keyframes feed-modal-in {
  from { opacity: 0; transform: translateY(12px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 768px) {
  .modal-overlay {
    align-items: flex-end;
    padding: 10px;
  }

  .modal-overlay > .modal {
    width: 100%;
    max-height: 84vh;
    padding: 20px 16px;
    border-radius: 18px;
  }
}

/* Creation modals — premium high-tech editorial surface. */
.modal-overlay > .modal {
  width: min(100%, 520px);
  padding: 22px;
}

.feed-modal-header {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) 34px;
  align-items: start;
  gap: 12px;
  margin: 4px 0 20px;
}

.feed-modal-icon {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  color: #e95a13;
  background: #fff5ef;
  border: 1px solid #ffd4bd;
  border-radius: 14px;
  box-shadow: 0 7px 16px rgba(30, 63, 88, .08);
  font-size: 1.1rem;
}

.modal-overlay > .modal .feed-modal-header h3 {
  margin: 2px 0 4px;
  font-size: 1.06rem;
}

.feed-modal-header p {
  margin: 0;
  color: #71899b;
  font-size: .76rem;
  font-weight: 550;
  line-height: 1.45;
}

.feed-modal-close {
  display: grid;
  width: 34px;
  height: 34px;
  padding: 0;
  place-items: center;
  border: 1px solid #dfe9ee;
  border-radius: 10px;
  color: #4e7799;
  background: #f5f8fa;
  cursor: pointer;
  transition: .18s ease;
}

.feed-modal-close:hover {
  color: #e95a13;
  background: #fff3ec;
  border-color: #ffc9aa;
}

.feed-modal-fields > input {
  width: 100%;
  margin-bottom: 12px;
}

.modal-overlay > .modal .feed-modal-upload {
  position: relative;
  min-height: 172px;
  margin: 0 0 13px;
  aspect-ratio: auto;
  border: 1px dashed #9bb2c2;
  border-radius: 14px;
  background: #f7fafb;
}

.modal-overlay > .modal .feed-modal-upload:hover {
  border-color: #e95a13;
  background: #fff8f4;
}

.modal-overlay > .modal .feed-modal-upload.has-media {
  min-height: 220px;
  border-style: solid;
  border-color: #d6e2e9;
  background: #eef3f6;
}

.feed-modal-cropper {
  position: relative;
  width: 100%;
  height: 280px;
}

.modal-overlay > .modal .feed-modal-upload video {
  display: block;
  width: 100%;
  max-height: 300px;
  object-fit: cover;
}

.modal-overlay > .modal .feed-modal-upload .image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  padding: 22px;
  color: #4e7799;
}

.modal-overlay > .modal .feed-modal-upload .image-placeholder > svg,
.modal-overlay > .modal .feed-modal-upload .image-placeholder .camera {
  display: grid;
  width: 38px;
  height: 38px;
  margin: 0 0 2px;
  place-items: center;
  border-radius: 12px;
  color: #e95a13;
  background: #fff0e8;
  font-size: 1rem;
}

.modal-overlay > .modal .feed-modal-upload .image-placeholder strong {
  color: #345269;
  font-size: .8rem;
  font-weight: 800;
}

.modal-overlay > .modal .feed-modal-upload .image-placeholder small,
.feed-modal-hint {
  color: #71899b;
  font-size: .7rem;
  font-weight: 600;
}

.feed-modal-hint {
  margin: -2px 0 14px;
  line-height: 1.45;
}

.feed-modal-error {
  margin: -4px 0 12px;
  padding: 9px 11px;
  border: 1px solid #ffcbb2;
  border-radius: 10px;
  color: #b73f09;
  background: #fff4ee;
  font-size: .74rem;
  font-weight: 700;
}

.modal-overlay > .modal .modal-actions {
  justify-content: stretch;
  margin-top: 2px;
  padding-top: 12px;
  border-top: 1px solid #e4edf1;
}

.modal-overlay > .modal .modal-actions button {
  display: inline-flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

@media (max-width: 768px) {
  .modal-overlay > .modal { padding: 19px 15px; }

  .feed-modal-header {
    grid-template-columns: 42px minmax(0, 1fr) 32px;
    gap: 10px;
    margin-bottom: 17px;
  }

  .feed-modal-icon { width: 42px; height: 42px; border-radius: 12px; }
  .feed-modal-cropper { height: 245px; }
  .modal-overlay > .modal .feed-modal-upload.has-media { min-height: 205px; }
}

/* Share modal — CarrerUp high-tech delivery panel. */
.send-post-modal-overlay {
  padding: 20px;
  background: rgba(20, 43, 61, .52);
}

.send-post-share-modal {
  position: relative;
  box-sizing: border-box;
  width: min(100%, 460px);
  max-height: min(82vh, 640px);
  padding: 21px;
  border: 1px solid rgba(148, 169, 186, .42);
  border-radius: 20px;
  color: #1d394f;
  background: #fbfcfd;
  box-shadow: 0 28px 75px rgba(12, 31, 47, .3), inset 0 1px #ffffff;
}

.send-post-share-modal::before {
  content: "";
  position: absolute;
  top: 0;
  right: 32px;
  left: 32px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #e95a13;
}

.send-post-share-header {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 32px;
  gap: 11px;
  align-items: start;
  margin: 4px 0 17px;
}

.send-post-share-header > span {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid #ffd5bf;
  border-radius: 13px;
  color: #e95a13;
  background: #fff4ed;
  font-size: 1rem;
}

.send-post-share-modal .send-post-share-header h3 {
  margin: 2px 0 4px;
  color: #1d394f;
  font-size: 1rem;
  font-weight: 850;
  text-align: left;
}

.send-post-share-header p {
  margin: 0;
  color: #71899b;
  font-size: .73rem;
  font-weight: 600;
  line-height: 1.4;
}

.send-post-share-close {
  display: grid;
  width: 32px;
  height: 32px;
  padding: 0;
  place-items: center;
  border: 1px solid #dfe9ee;
  border-radius: 9px;
  color: #4e7799;
  background: #f5f8fa;
  cursor: pointer;
  transition: .18s ease;
}

.send-post-share-close:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }

.send-post-share-list {
  max-height: 315px;
  padding: 4px;
  border: 1px solid #e1ebf0;
  border-radius: 13px;
  background: #f7fafb;
}

.send-post-share-list::-webkit-scrollbar-thumb { background: #94a9ba; }

.send-post-share-item {
  margin: 2px 0;
  padding: 8px;
  border-radius: 10px;
  color: #345269;
  background: transparent;
}

.send-post-share-item:hover { background: #fff3ec; }

.send-post-share-item label { gap: 2px; color: #345269; font-size: .78rem; font-weight: 750; }

.send-post-share-item input[type="checkbox"] {
  width: 17px;
  height: 17px;
  margin-right: 9px;
  border: 1px solid #9fb4c2;
  border-radius: 6px;
  background: #ffffff;
}

.send-post-share-item input[type="checkbox"]:checked { background: #e95a13; border-color: #e95a13; }
.send-post-share-item input[type="checkbox"]:checked::after { top: 0; left: 3px; }

.send-post-share-error {
  margin: 10px 0 -2px;
  padding: 9px 11px;
  border: 1px solid #ffcbb2;
  border-radius: 10px;
  color: #b73f09;
  background: #fff4ee;
  font-size: .74rem;
  font-weight: 750;
}

.send-post-modal-actions {
  margin-top: 15px;
  padding-top: 13px;
  border-top: 1px solid #e3ecef;
}

.send-post-modal-actions button:first-child,
.send-post-modal-actions button:last-child {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 41px;
  padding: 8px 13px;
  border-radius: 10px;
  font-size: .76rem;
  font-weight: 850;
}

.send-post-modal-actions button:first-child { border: 1px solid #dbe6ec; color: #4e7799; background: #f3f7f9; }
.send-post-modal-actions button:last-child { border: 1px solid #e95a13; color: #ffffff; background: #e95a13; box-shadow: 0 7px 16px rgba(233, 90, 19, .18); }
.send-post-modal-actions button:last-child:hover { background: #d84f0d; transform: translateY(-1px); }

@media (max-width: 768px) {
  .send-post-modal-overlay {
    position: fixed;
    inset: 0;
    width: auto;
    height: auto;
    align-items: center;
    justify-content: center;
    padding: 14px max(14px, env(safe-area-inset-right)) 14px max(14px, env(safe-area-inset-left));
  }

  .send-post-share-modal {
    width: min(100%, 440px);
    margin: 0;
    transform: none;
    max-height: min(68svh, 560px);
    padding: 17px 13px 13px;
    border-radius: 18px;
  }

  .send-post-share-modal::before { right: 22px; left: 22px; }

  .send-post-share-header {
    grid-template-columns: 39px minmax(0, 1fr) 31px;
    gap: 9px;
    margin: 2px 1px 13px;
  }

  .send-post-share-header > span { width: 39px; height: 39px; border-radius: 12px; font-size: .9rem; }
  .send-post-share-modal .send-post-share-header h3 { margin-top: 1px; font-size: .92rem; }
  .send-post-share-header p { font-size: .68rem; line-height: 1.35; }
  .send-post-share-close { width: 31px; height: 31px; }

  .send-post-share-list {
    max-height: min(32svh, 260px);
    min-height: 0;
    padding: 3px;
    border-radius: 12px;
  }

  .send-post-share-item { min-height: 38px; padding: 6px 8px; }
  .send-post-share-item label { font-size: .74rem; }

  .send-post-share-error { margin: 8px 0 -2px; padding: 8px 10px; font-size: .7rem; }

  .send-post-modal-actions {
    position: static;
    margin: 11px -13px -13px;
    padding: 11px 13px calc(11px + env(safe-area-inset-bottom));
    background: #fbfcfd;
  }

  .send-post-modal-actions button:first-child,
  .send-post-modal-actions button:last-child {
    min-height: 42px;
    padding: 8px 10px;
    font-size: .73rem;
  }
}

/* Comments — CarrerUp premium high-tech conversation layer. */
.comment-panel,
.viewer-comment-panel {
  color: #29475e;
  background: #fbfcfd;
}

.comment-header {
  position: relative;
  min-height: 48px;
  padding: 13px 15px;
  align-items: center;
  border-bottom: 1px solid #e1ebf0;
  color: #1d394f;
  background: #ffffff;
}

.comment-header::before {
  content: "";
  position: absolute;
  top: 0;
  right: 22px;
  left: 22px;
  height: 2px;
  background: #e95a13;
}

.comments-title { font-size: .83rem; font-weight: 850; letter-spacing: -.01em; }

.close-comments-btn {
  width: 31px;
  height: 31px;
  border: 1px solid #dce7ed;
  border-radius: 9px;
  color: #4e7799;
  background: #f5f8fa;
  font-size: 1rem;
}

.close-comments-btn:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; transform: none; }

.comment-list {
  padding: 11px;
  background: #fbfcfd;
  scrollbar-color: #94a9ba transparent;
}

.comment-item {
  gap: 9px;
  margin: 0;
  padding: 11px 2px;
  border-bottom: 1px solid #e8eff2;
}

.comment-item:not(:last-child) { border-bottom-color: #e8eff2; }
.comment-left { min-width: 0; }

.comment-top { gap: 6px; min-width: 0; }
.comment-top b,
.reply-content b { overflow: hidden; color: #29475e; font-size: .76rem; font-weight: 850; text-overflow: ellipsis; white-space: nowrap; }

.comment-date { color: #94a9ba; font-size: .63rem; font-weight: 650; white-space: nowrap; }

.comment-left > p,
.reply-item > p { margin: 5px 0 0; color: #426076; font-size: .78rem; line-height: 1.52; word-break: break-word; }

.pin-badge {
  margin-left: 0;
  padding: 3px 6px;
  border: 1px solid #ffd9c5;
  border-radius: 7px;
  color: #d84f0d;
  background: #fff6f1;
  font-size: .59rem;
  font-weight: 800;
}

.comment-bottom-actions,
.reply-actions-row { gap: 4px; margin-top: 7px; flex-wrap: wrap; }

.comment-bottom-actions button,
.reply-actions-row button {
  margin: 0;
  padding: 3px 6px;
  border: 0;
  border-radius: 7px;
  color: #71899b;
  background: transparent;
  font-size: .64rem;
  font-weight: 750;
}

.comment-bottom-actions button:hover,
.reply-actions-row button:hover { color: #e95a13; background: #fff3ec; transform: none; }
.comment-bottom-actions .delete-comment { color: #c14b21; }

.comment-like-section { min-width: 31px; padding-top: 1px; }

.like-comment {
  display: grid;
  width: 29px;
  height: 29px;
  padding: 0;
  place-items: center;
  border: 1px solid transparent;
  border-radius: 9px;
  color: #71899b;
}

.like-comment:hover { color: #e95a13; background: #fff3ec; transform: none; }
.like-comment.liked { color: #e95a13; background: #fff3ec; }
.like-count { color: #71899b; font-size: .62rem; font-weight: 750; }

.replies-container {
  margin-top: 9px;
  padding: 2px 0 0 11px;
  border-left: 1px solid #cddde5;
  gap: 7px;
}

.reply-item {
  padding: 7px 35px 7px 9px;
  border: 1px solid #e5edf1;
  border-radius: 10px;
  background: #f5f8fa;
}

.reply-content { gap: 5px; align-items: center; }
.reply-item .comment-like-section { top: 6px; right: 3px; }
.reply-item .comment-like-section .like-comment { width: 25px; height: 25px; }
.reply-item .comment-like-section .like-count { display: none; }

/* Energetic like feedback shared by feed posts. */
.post-actions .post-like-btn,
.pv-like-btn {
  position: relative;
  isolation: isolate;
  overflow: visible;
}

.modal-overlay > .modal .feed-caption-textarea {
  display: block;
  width: 100%;
  min-height: 104px;
  max-height: 190px;
  resize: vertical;
  overflow-y: auto;
  line-height: 1.5;
  scrollbar-width: thin;
  scrollbar-color: #94a9ba transparent;
}

.modal-overlay > .modal .feed-caption-textarea::-webkit-scrollbar {
  width: 5px;
}

.modal-overlay > .modal .feed-caption-textarea::-webkit-scrollbar-thumb {
  border-radius: 99px;
  background: #94a9ba;
}

@media (max-width: 600px) {
  .modal-overlay > .modal .feed-caption-textarea {
    min-height: 118px;
    max-height: 32dvh;
    resize: none;
    font-size: 16px;
  }
}
.post-actions .post-like-btn.just-liked svg,
.pv-like-btn.just-liked svg {
  color: #e95a13;
  animation: postLikeHeartWow .72s cubic-bezier(.18,.89,.32,1.5) both;
  filter: drop-shadow(0 5px 8px rgba(233,90,19,.32));
}
.post-actions .post-like-btn.just-liked::before,
.pv-like-btn.just-liked::before {
  content: "";
  position: absolute;
  z-index: -1;
  width: 30px;
  height: 30px;
  border: 2px solid rgba(233,90,19,.58);
  border-radius: 50%;
  animation: postLikeShockwave .72s ease-out both;
}
.post-actions .post-like-btn.just-liked::after,
.pv-like-btn.just-liked::after {
  content: "✦";
  position: absolute;
  top: -9px;
  right: 2px;
  color: #e95a13;
  font-size: 11px;
  text-shadow: -19px 14px #e0946e, 2px 27px #e95a13, 22px 14px #f3a477;
  pointer-events: none;
  animation: postLikeParticles .78s ease-out both;
}
@keyframes postLikeHeartWow {
  0% { transform: scale(.45) rotate(-24deg); }
  42% { transform: scale(1.65) rotate(13deg); }
  68% { transform: scale(.88) rotate(-7deg); }
  100% { transform: scale(1.08) rotate(0); }
}
@keyframes postLikeShockwave {
  from { opacity: .9; transform: scale(.35); }
  to { opacity: 0; transform: scale(2.15); }
}
@keyframes postLikeParticles {
  0% { opacity: 0; transform: scale(.3) rotate(-15deg); }
  35% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-13px) scale(1.3) rotate(18deg); }
}

.reply-box,
.edit-comment-box {
  gap: 7px;
  margin-top: 9px;
  padding: 9px;
  border: 1px solid #dbe7ed;
  border-radius: 10px;
  background: #f7fafb;
}

.reply-box input,
.edit-comment-box input {
  box-sizing: border-box;
  width: 100%;
  padding: 9px 10px;
  border: 1px solid #d3e0e7;
  border-radius: 9px;
  color: #29475e;
  background: #ffffff;
  font-size: .74rem;
}

.reply-box input:focus,
.edit-comment-box input:focus { outline: 0; border-color: #e95a13; box-shadow: 0 0 0 3px rgba(233, 90, 19, .09); }

.reply-actions,
.edit-actions { gap: 6px; margin-top: 0; }

.reply-actions button,
.edit-actions button {
  padding: 6px 9px;
  border-radius: 8px;
  font-size: .64rem;
  font-weight: 800;
}

.reply-actions button:first-child,
.edit-actions button:first-child { border: 1px solid #dbe6ec; color: #4e7799; background: #f2f6f8; }
.reply-actions button:last-child,
.edit-actions button:last-child { border: 1px solid #e95a13; color: #ffffff; background: #e95a13; box-shadow: none; }
.reply-actions button:last-child:hover,
.edit-actions button:last-child:hover { background: #d84f0d; box-shadow: none; transform: none; }

.show-more-replies,
.hide-replies { color: #e95a13; font-size: .65rem; font-weight: 800; }
.show-more-replies:hover,
.hide-replies:hover { text-decoration: none; transform: none; }

.comment-input {
  gap: 8px;
  padding: 11px;
  border-top: 1px solid #e1ebf0;
  background: #ffffff;
}

.comment-input input {
  min-width: 0;
  padding: 10px 11px;
  border: 1px solid #d7e3e9;
  border-radius: 10px;
  color: #29475e;
  background: #f3f7f9;
  font-size: .76rem;
}

.comment-input input:focus { border-color: #e95a13; background: #ffffff; box-shadow: 0 0 0 3px rgba(233, 90, 19, .09); }

.comment-input button {
  padding: 9px 12px;
  border: 1px solid #e95a13;
  border-radius: 10px;
  color: #ffffff;
  background: #e95a13;
  font-size: .7rem;
  font-weight: 850;
  cursor: pointer;
}

.comment-input button:hover { background: #d84f0d; }
.no-comments { margin: 20px 4px; color: #71899b; font-size: .78rem; text-align: center; }

@media (max-width: 768px) {
  .comment-list { padding: 8px; }
  .comment-item { gap: 6px; padding: 9px 1px; }
  .comment-top b, .reply-content b { max-width: 125px; font-size: .72rem; }
  .comment-left > p, .reply-item > p { font-size: .74rem; line-height: 1.45; }
  .comment-bottom-actions button, .reply-actions-row button { font-size: .61rem; }
  .comment-input { padding: 9px; }
  .comment-input input { padding: 9px; font-size: .72rem; }
  .comment-input button { padding: 9px 10px; font-size: .66rem; }
  .replies-container { padding-left: 8px; }
  .reply-item { padding: 7px 29px 7px 8px; }
}

/* Feed comment panel: anchor to the reading column, not the page center. */
.feed-canvas .comment-overlay {
  position: fixed;
  inset: auto auto 0 50%;
  width: min(680px, calc(100vw - 28px));
  height: auto;
  margin: 0;
  transform: translateX(-50%);
  display: block;
  z-index: 9999;
}

.feed-canvas .comment-panel {
  width: 100%;
  height: min(60svh, 560px);
  max-height: 60svh;
  overflow: hidden;
  border: 1px solid rgba(148, 169, 186, .38);
  border-bottom: 0;
  border-radius: 18px 18px 0 0;
  box-shadow: 0 24px 60px rgba(12, 31, 47, .22), inset 0 1px #ffffff;
  animation: comment-panel-in .28s cubic-bezier(.2, .8, .2, 1);
}

@keyframes comment-panel-in {
  from { opacity: 0; transform: translateY(100%); }
  to { opacity: 1; transform: translateY(0); }
}

@media (min-width: 1150px) {
  .feed-canvas .comment-overlay {
    left: calc(50% - 70px);
  }
}

@media (max-width: 768px) {
  .feed-canvas .comment-overlay {
    width: 100%;
  }

  .feed-canvas .comment-panel {
    height: 60svh;
    max-height: 60svh;
    border-radius: 18px 18px 0 0;
  }
}
.native-feed-welcome,
.native-pull-refresh {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/Feed.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA,iBAAiB;AACjB;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;EACnB,gBAAgB;;EAEhB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA,sBAAsB;;AAEtB;EACE;IACE,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,oBAAoB;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,wCAAwC;EACxC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;;AAGA;;;;;;;;;;GAUG;;AAEH;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;;AAGA;;;;;;;;GAQG;;;AAGH;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;;AAGA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,oCAAoC;;EAEpC,sBAAsB;;EAEtB,eAAe;;EAEf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;;AAGA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;;;AAIA;;;;;;;;GAQG;;;AAGH;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;;;;;;;;;;;GAWG;;;;AAIH,iBAAiB;;AAEjB;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;;;AAIA,kBAAkB;;AAElB;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;EACE,OAAO,YAAY,EAAE;EACrB,KAAK,UAAU,EAAE;AACnB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;;;;AAKA,aAAa;;AAEb;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;GAIG;;AAEH,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,UAAU;AACV;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,iBAAiB;;;AAGjB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,0BAA0B;AAC5B;;;AAGA,YAAY;AACZ;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;;AAGA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,2DAA2D;EAC3D,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;;;;;AAMA;;EAEE,eAAe;;EAEf,MAAM;EACN,OAAO;;EAEP,WAAW;EACX,WAAW;;EAEX,cAAc;;EAEd,mBAAmB;;AAErB;;AAEA;;EAEE,YAAY;;EAEZ,UAAU;;EAEV,mBAAmB;;EAEnB;oCACkC;;AAEpC;;AAEA;;EAEE,eAAe;;EAEf,SAAS;;EAET,SAAS;;EAET;oBACkB;;EAElB,iBAAiB;;EAEjB,kBAAkB;;EAElB,oBAAoB;;EAEpB,eAAe;;EAEf,gBAAgB;;EAEhB;gCAC8B;;AAEhC;;AAEA;;EAEE;;IAEE;uBACmB;;EAErB;;EAEA;;IAEE;sBACkB;;EAEpB;;AAEF;;;AAGA;;EAEE,eAAe;;EAEf,YAAY;EACZ,SAAS;;EAET;oBACkB;;EAElB,iBAAiB;;EAEjB,kBAAkB;;EAElB,mBAAmB;;EAEnB,aAAa;;EAEb,mBAAmB;;EAEnB,SAAS;;EAET;kCACgC;;EAEhC,cAAc;;EAEd;qBACmB;;AAErB;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;;EAElB,aAAa;;EAEb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,YAAY;;EAEZ,eAAe;;EAEf,iBAAiB;;AAEnB;;AAEA;;EAEE;;IAEE,UAAU;;IAEV;;aAES;;EAEX;;EAEA;;IAEE,UAAU;;IAEV;;UAEM;;EAER;;AAEF;;;AAGA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,QAAQ;;AAEV;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;;EAEpB,eAAe;;AAEjB;;AAEA;;EAEE,aAAa;;AAEf;;AAEA;;EAEE,cAAc;;EAEd,WAAW;EACX,eAAe;;EAEf,wBAAwB;;EAExB,eAAe;;EAEf,cAAc;;EAEd,SAAS;;AAEX;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6DG;;;;AAIH;;EAEE,eAAe;;EAEf,YAAY;EACZ,SAAS;;EAET,2BAA2B;;EAE3B,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,iBAAiB;;EAEjB,kBAAkB;;EAElB,mBAAmB;;EAEnB;kCACgC;;EAEhC;wBACsB;;EAEtB,eAAe;;AAEjB;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;;EAElB,8BAA8B;;EAE9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;;EAEZ,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;;EAEE,cAAc;EACd,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,eAAe;;AAEjB;;AAEA;;EAEE;;IAEE,UAAU;;IAEV;2BACuB;;EAEzB;;EAEA;;IAEE,UAAU;;IAEV;wBACoB;;EAEtB;;AAEF;;;AAGA;;GAEG;;AAEH,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA;;;EAGE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qCAAqC,cAAc,EAAE;;AAErD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,SAAW;EACX,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,iCAAiC,cAAc,EAAE;;AAEjD;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,QAAQ;EACV;;EAEA;;;IAGE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,6EAA6E;AAC7E;EACE,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;AACF;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,SAAS;IACT,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,iFAAiF;AACjF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kFAAkF;AAClF;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mDAAmD;IACnD,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB,mDAAmD;EACrD;;EAEA;IACE,2CAA2C;IAC3C,YAAY;EACd;;EAEA;IACE,4CAA4C;IAC5C,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,kEAAkE;EACpE;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,oCAAoC,cAAc,EAAE,gBAAgB,EAAE;;EAEtE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,eAAe;IACf,SAAS;IACT,gDAAgD;IAChD,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,qCAAqC;IACrC,oCAAoC;IACpC,uCAAuC;EACzC;AACF;;AAEA,iEAAiE;AACjE;EACE,oEAAoE;EACpE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kEAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,SAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,0BAA0B,kBAAkB,EAAE;;EAE9C;IACE,+CAA+C;IAC/C,SAAS;IACT,mBAAmB;EACrB;;EAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;EACnE,sBAAsB,aAAa,EAAE;EACrC,uDAAuD,iBAAiB,EAAE;AAC5E;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA,+BAA+B,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAE3F;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iDAAiD,mBAAmB,EAAE;;AAEtE;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA,8BAA8B,mBAAmB,EAAE;;AAEnD,8BAA8B,QAAQ,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAE7F;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uDAAuD,mBAAmB,EAAE,qBAAqB,EAAE;AACnG,8DAA8D,MAAM,EAAE,SAAS,EAAE;;AAEjF;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8CAA8C,yBAAyB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9G,6CAA6C,yBAAyB,EAAE,cAAc,EAAE,mBAAmB,EAAE,6CAA6C,EAAE;AAC5J,mDAAmD,mBAAmB,EAAE,2BAA2B,EAAE;;AAErG;EACE;IACE,eAAe;IACf,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,6FAA6F;EAC/F;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,iCAAiC,WAAW,EAAE,UAAU,EAAE;;EAE1D;IACE,+CAA+C;IAC/C,QAAQ;IACR,oBAAoB;EACtB;;EAEA,iCAAiC,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;EACnG,oDAAoD,eAAe,EAAE,iBAAiB,EAAE;EACxF,4BAA4B,iBAAiB,EAAE,iBAAiB,EAAE;EAClE,yBAAyB,WAAW,EAAE,YAAY,EAAE;;EAEpD;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE;EAC5D,8BAA8B,iBAAiB,EAAE;;EAEjD,yBAAyB,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;EAElF;IACE,gBAAgB;IAChB,wBAAwB;IACxB,2DAA2D;IAC3D,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,8DAA8D;AAC9D;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAE/E;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4BAA4B,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,eAAe,EAAE;;AAEzG;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,iCAAiC,4BAA4B,EAAE;AAC/D,gBAAgB,YAAY,EAAE;;AAE9B,eAAe,QAAQ,EAAE,YAAY,EAAE;AACvC;mBACmB,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAExI,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE1F;kBACkB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAEjH;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;qBACqB,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEjE;;EAEE,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;kCACkC,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACxF,0CAA0C,cAAc,EAAE;;AAE1D,wBAAwB,eAAe,EAAE,gBAAgB,EAAE;;AAE3D;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC5E,sBAAsB,cAAc,EAAE,mBAAmB,EAAE;AAC3D,cAAc,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB,QAAQ,EAAE,mBAAmB,EAAE;AAChD,oCAAoC,QAAQ,EAAE,UAAU,EAAE;AAC1D,kDAAkD,WAAW,EAAE,YAAY,EAAE;AAC7E,gDAAgD,aAAa,EAAE;;AAE/D,kDAAkD;AAClD;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;AACF;AACA;;EAEE,cAAc;EACd,mEAAmE;EACnE,kDAAkD;AACpD;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,+CAA+C;AACjD;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,oEAAoE;EACpE,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE,KAAK,oCAAoC,EAAE;EAC3C,MAAM,oCAAoC,EAAE;EAC5C,MAAM,mCAAmC,EAAE;EAC3C,OAAO,gCAAgC,EAAE;AAC3C;AACA;EACE,OAAO,WAAW,EAAE,qBAAqB,EAAE;EAC3C,KAAK,UAAU,EAAE,sBAAsB,EAAE;AAC3C;AACA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,qDAAqD,EAAE;AAC5E;;AAEA;;EAEE,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;gCACgC,UAAU,EAAE,qBAAqB,EAAE,4CAA4C,EAAE;;AAEjH;gBACgB,QAAQ,EAAE,aAAa,EAAE;;AAEzC;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;mCACmC,yBAAyB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnG;kCACkC,yBAAyB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACpH;wCACwC,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEhG;gBACgB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACrE;sBACsB,qBAAqB,EAAE,eAAe,EAAE;;AAE9D;EACE,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,6BAA6B,qBAAqB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE;;AAEvH;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B,mBAAmB,EAAE;AACnD,eAAe,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;;AAExF;EACE,gBAAgB,YAAY,EAAE;EAC9B,gBAAgB,QAAQ,EAAE,gBAAgB,EAAE;EAC5C,mCAAmC,gBAAgB,EAAE,iBAAiB,EAAE;EACxE,qCAAqC,iBAAiB,EAAE,iBAAiB,EAAE;EAC3E,4DAA4D,iBAAiB,EAAE;EAC/E,iBAAiB,YAAY,EAAE;EAC/B,uBAAuB,YAAY,EAAE,iBAAiB,EAAE;EACxD,wBAAwB,iBAAiB,EAAE,iBAAiB,EAAE;EAC9D,qBAAqB,iBAAiB,EAAE;EACxC,cAAc,yBAAyB,EAAE;AAC3C;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,4BAA4B;EAC5B,kEAAkE;EAClE,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;AACA;;EAEE,aAAa;AACf","sourcesContent":[".feed {\n  max-width: 600px;\n  margin: auto;\n  padding: 20px;\n}\n\n/* CREATE POST */\n.create-post {\n  background: white;\n  padding: 15px;\n  border-radius: 10px;\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.create-post img {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n}\n\n.create-post textarea {\n  flex: 1;\n  border: none;\n  resize: none;\n  outline: none;\n  background: #f0f2f5;\n  border-radius: 20px;\n  padding: 10px 15px;\n  font-size: 16px;\n}\n\n.error-video {\n  margin-top: 0 !important;\n}\n\n.create-post button {\n  background: var(--primary-200);\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* POST */\n.post {\n  position: relative;\n  background: white;\n  border-radius: 10px;\n  padding: 15px;\n  margin-bottom: 15px;\n}\n\n.post-header {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.post-header img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.post-header span {\n  font-size: 12px;\n  color: #777;\n}\n\n.post-text {\n  margin: 10px 0;\n}\n\n.post-image {\n  width: 100%;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n.post-link {\n  display: block;\n  margin-top: 10px;\n  color: #1877f2;\n}\n\n/* STATS */\n.post-stats {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #555;\n  margin-top: 10px;\n}\n\n/* ACTIONS */\n.post-actions {\n  display: flex;\n  justify-content: space-around;\n  border-top: 1px solid #eee;\n  margin-top: 10px;\n  padding-top: 8px;\n}\n\n.post-actions button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  color: #555;\n}\n\n.post-actions button.active {\n  color: var(--primary-200);\n}\n\n\n\n/* OPTIONS */\n.post-options {\n  display: flex;\n  justify-content: space-between;\n  background: white;\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.post-options button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex: 1;\n  margin: 0 5px;\n  padding: 10px;\n  border: none;\n  border-radius: 8px;\n  background: #f0f2f5;\n  cursor: pointer;\n  font-weight: 500;\n  transition: 0.3s;\n  color: var(--primary-200);\n}\n\n.post-options button:hover {\n  background: var(--primary-200);\n  color: white;\n}\n\n/* MODAL */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  width: 360px;\n  padding: 20px;\n  border-radius: 12px;\n  animation: scaleIn 0.2s ease;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.modal h3 {\n  margin-bottom: 15px;\n}\n\n.modal input,\n.modal textarea {\n  width: 100%;\n  margin-bottom: 12px;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  outline: none;\n  font-size: 16px;\n}\n\n.modal textarea {\n  min-height: 100px;\n  resize: none;\n}\n\n/* ACTIONS */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.modal-actions .cancel {\n  background: #eee;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.modal-actions .publish {\n  background: var(--primary-200);\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n\n/* IMAGE UPLOAD */\n.image-upload {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 10px;\n  border: 2px dashed #ccc;\n  cursor: pointer;\n  overflow: hidden;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-bottom: 12px;\n  transition: 0.3s;\n\n  background: #fafafa;\n  transition: 0.2s;\n}\n\n.post-text-wrapper{\n  margin:12px 15px;\n}\n\n\n\n.image-upload:hover {\n  border-color: var(--primary-200);\n  background: #f5f8ff;\n}\n\n.image-upload img {\n  width: 100%;\n  /* height: 100%; */\n  object-fit: cover;\n}\n\n.image-placeholder {\n  text-align: center;\n  color: #777;\n}\n\n.image-placeholder .camera {\n  font-size: 36px;\n  display: block;\n}\n\n\n/* responsive mobile */\n\n@media (max-width: 768px) {\n  .feed {\n    max-width: 100%;\n    padding: 12px;\n    padding-bottom: 80px;\n    /* navbar bottom */\n  }\n}\n\n@media (max-width: 768px) {\n  .create-post {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .create-post img {\n    width: 40px;\n    height: 40px;\n  }\n\n  .create-post textarea {\n    font-size: 16px;\n  }\n\n  .create-post button {\n    padding: 6px 10px;\n    font-size: 14px;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .post-actions button {\n    font-size: 14px;\n    padding: 8px 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .post-options {\n    gap: 6px;\n  }\n\n  .post-options button {\n    padding: 8px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .image-upload {\n    /* height: 150px; */\n  }\n\n  .image-placeholder .camera {\n    font-size: 28px;\n  }\n}\n\n\n/* Loading spinner */\n\n.feed-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 0;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--bg-200);\n  border-top: 4px solid var(--primary-100);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/* .comment-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40%;\n  background: rgba(0,0,0,0.2);\n  display: flex;\n  align-items: flex-end;\n  z-index: 50;\n} */\n\n.comment-overlay {\n  position: fixed;\n  inset: 0;\n  /* background: rgba(0, 0, 0, 0.4); */\n  display: flex;\n  align-items: flex-end;\n  max-width: 600px;\n  margin: auto;\n  z-index: 9999;\n  /* height: 40%; */\n}\n\n\n/* .comment-panel {\n  background: white;\n  width: 100%;\n  height: 100%;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  display: flex;\n  flex-direction: column;\n} */\n\n\n.comment-panel {\n  background: white;\n  width: 100%;\n  height: 50%;\n  max-height: 50%;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.25s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n\n.comment-header {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n}\n\n.close-comments-btn {\n  width: 38px;\n  height: 38px;\n\n  border: none;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: rgba(255, 255, 255, .08);\n\n  color: var(--text-100);\n\n  font-size: 20px;\n\n  transition: .25s ease;\n}\n\n.close-comments-btn:hover {\n  transform: rotate(90deg);\n  background: rgba(255, 255, 255, .15);\n}\n\n.comment-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.comment-item {\n  margin-bottom: 8px;\n}\n\n.comment-input {\n  display: flex;\n  padding: 8px;\n  border-top: 1px solid #eee;\n}\n\n.comment-input input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 6px;\n  font-size: 16px;\n}\n\n.comment-input button {\n  background: var(--primary-200);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 20px;\n}\n\n.comment-top {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n}\n\n.comment-date {\n  color: #888;\n  font-size: 11px;\n}\n\n.delete-comment {\n  background: none;\n  border: none;\n  color: var(--primary-100);\n  font-size: 11px;\n  cursor: pointer;\n  padding: 0;\n}\n\n\n.pinned {\n  background: #fff8e1;\n  border-left: 3px solid var(--primary-100);\n}\n\n.pin-comment {\n  background: none;\n  border: none;\n  color: var(--primary-200);\n  font-size: 11px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.pin-badge {\n  font-size: 11px;\n  color: var(--primary-100);\n  margin-left: 6px;\n}\n\n.pinned {\n  animation: pinFlash 1.2s ease;\n  background: #fff8e1;\n}\n\n@keyframes pinFlash {\n  0% {\n    background: #ffe082;\n  }\n\n  100% {\n    background: #fff8e1;\n  }\n}\n\n.comment-item {\n  padding: 10px 0;\n}\n\n.comment-item:not(:last-child) {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n\n\n/* .comment-header::before {\n  content: \"\";\n  width: 40px;\n  height: 4px;\n  background: #ccc;\n  border-radius: 4px;\n  display: block;\n  margin: 0 auto 8px;\n} */\n\n\n.post-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.post-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.post-user-info {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.post-user-info span {\n  font-size: 12px;\n  color: var(--text-200);\n}\n\n.post-menu-dropdown {\n  position: absolute;\n  right: 0;\n  top: 28px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  /* padding: 6px 0; */\n  min-width: 160px;\n  z-index: 20;\n  animation: fadeInMenu 0.15s ease;\n  margin-top: 20px;\n  margin-right: 10px;\n\n}\n\n.post-menu-dropdown button {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 10px 16px;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--primary-100);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.2s ease;\n}\n\n.post-menu-dropdown button:hover {\n  background: rgba(233, 90, 19, 0.08);\n}\n\n@keyframes fadeInMenu {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n/* .zoom-control {\n  margin-top: 10px;\n}\n\n.zoom-control label {\n  font-size: 13px;\n  color: #555;\n}\n\n.zoom-control input {\n  width: 100%;\n} */\n\n\n\n/* Skelton post */\n\n.skeleton-post .avatar {\n  width: 40px;\n  /* height: 40px; */\n  border-radius: 50%;\n}\n\n.skeleton-post .name {\n  width: 120px;\n  height: 14px;\n  margin-bottom: 6px;\n}\n\n.skeleton-post .date {\n  width: 80px;\n  height: 12px;\n}\n\n.skeleton-post .text {\n  height: 16px;\n  margin: 12px 0;\n}\n\n.skeleton-post .image {\n  height: 260px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.skeleton-post .btn {\n  height: 28px;\n  width: 80px;\n  margin-right: 10px;\n}\n\n\n\n/* skelton style */\n\n.skeleton {\n  background: #eaf0f4;\n  animation: skeleton-loading 1.2s ease-in-out infinite alternate;\n  border-radius: 6px;\n}\n\n@keyframes skeleton-loading {\n  from { opacity: .58; }\n  to { opacity: 1; }\n}\n\n\n.create-post .avatar {\n  width: 40px;\n  /* height: 40px; */\n  border-radius: 50%;\n}\n\n\n.comment-skeleton {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.comment-skeleton .avatar {\n  /* width: 28px; */\n  /* height: 28px; */\n  border-radius: 50%;\n}\n\n.comment-skeleton .text {\n  flex: 1;\n  height: 14px;\n}\n\n.no-comments {\n  display: flex;\n  justify-content: center;\n  margin-top: 100px;\n}\n\n.post-video-container {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n  border-radius: 8px;\n  background: black;\n}\n\n.post-video-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n\n.edit-post-modal {\n  max-width: 500px;\n}\n\n.edit-preview-image {\n  width: 100%;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.edit-preview-video {\n  width: 100%;\n  aspect-ratio: 1/1;\n  overflow: hidden;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.edit-preview-video video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.edit-textarea {\n  width: 100%;\n  /* min-height: 80px; */\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  resize: none;\n}\n\n\n\n\n/* comments */\n\n.comment-main {\n  display: flex;\n  justify-content: space-between;\n}\n\n.comment-right {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 12px;\n}\n\n.comment-actions {\n  display: flex;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.comment-reply {\n  margin-left: 30px;\n  border-left: 2px solid #eee;\n  padding-left: 10px;\n}\n\n.reply-box {\n  margin-top: 5px;\n  display: flex;\n  gap: 5px;\n}\n\n.comment-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 0;\n}\n\n/* LEFT */\n.comment-left {\n  flex: 1;\n}\n\n.comment-top {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.comment-bottom-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n/* RIGHT (LIKE) */\n.comment-like-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 40px;\n}\n\n.like-comment {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #888;\n  transition: 0.2s;\n}\n\n.like-comment:hover {\n  transform: scale(1.2);\n}\n\n.like-comment.liked {\n  color: var(--primary-100);\n}\n\n.like-count {\n  font-size: 12px;\n  color: #666;\n}\n\n.edit-comment-box {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.edit-comment-box input {\n  padding: 6px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\n.edit-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.edit-comment {\n  color: #1877f2;\n  cursor: pointer;\n  background: none;\n  border: none;\n}\n\n\n.edit-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n/* BASE */\n.edit-actions button {\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.25s ease;\n}\n\n/* CANCEL */\n.edit-actions button:first-child {\n  background: transparent;\n  color: #666;\n  border: 1px solid #ddd;\n}\n\n/* .edit-actions button:first-child:hover {\n  background: #f5f5f5;\n  color: #000;\n  transform: scale(1.05);\n} */\n\n/* SAVE (🔥 WOW BUTTON) */\n.edit-actions button:last-child {\n  background: var(--primary-100);\n  color: white;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n/* HOVER */\n.edit-actions button:last-child:hover {\n  transform: translateY(-2px) scale(1.05);\n  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.5);\n}\n\n/* CLICK EFFECT */\n.edit-actions button:active {\n  transform: scale(0.95);\n}\n\n\n/* REPLY BUTTON */\n.reply-comment {\n  background: none;\n  border: none;\n  color: var(--primary-100);\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.reply-comment:hover {\n  transform: scale(1.05);\n}\n\n/* INPUT REPLY */\n.reply-box {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.reply-box input {\n  padding: 8px;\n  border-radius: 20px;\n  border: 1px solid #ddd;\n  outline: none;\n  font-size: 16px;\n}\n\n/* ACTIONS */\n.reply-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.reply-actions button {\n  border-radius: 20px;\n  padding: 5px 12px;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.reply-actions button:first-child {\n  background: #f1f1f1;\n}\n\n.reply-actions button:last-child {\n  background: var(--primary-100);\n  color: white;\n}\n\n/* REPLIES CONTAINER */\n.replies-container {\n  margin-top: 10px;\n  padding-left: 12px;\n  border-left: 2px solid #eee;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* SINGLE REPLY */\n\n\n.reply-item {\n  /* background: #f7f9fc; */\n  /* padding: 8px 10px; */\n  border-radius: 10px;\n  transition: 0.2s;\n}\n\n\n\n.reply-content {\n  display: flex;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.reply-date {\n  color: #888;\n  font-size: 11px;\n}\n\n/* ANIMATION */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.show-more-replies,\n.hide-replies {\n  font-size: 12px;\n  color: var(--primary-100);\n  cursor: pointer;\n  margin-top: 4px;\n  display: inline-block;\n  font-weight: 600;\n  transition: 0.2s;\n}\n\n.show-more-replies:hover,\n.hide-replies:hover {\n  text-decoration: underline;\n  transform: translateX(2px);\n}\n\n\n/* MENTION */\n.mention {\n  color: var(--primary-100);\n  font-weight: 700;\n  margin-right: 4px;\n}\n\n/* ACTIONS REPLY */\n.reply-actions-row {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.reply-actions-row button {\n  background: none;\n  border: none;\n  font-size: 12px;\n  color: #666;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.reply-actions-row button:hover {\n  color: var(--primary-100);\n  transform: translateX(2px);\n}\n\n\n.reply-item {\n  position: relative;\n}\n\n.reply-item .comment-like-section {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n\n.clickable-username {\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.clickable-username:hover {\n  color: var(--primary-200);\n}\n\n.post-menu-dropdown .edit_btn_drop {\n  color: var(--primary-200);\n}\n\n.post-menu-icon {\n  cursor: pointer;\n}\n\n.post-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.follow-btn-post {\n  background: var(--primary-200);\n  color: white;\n  border: none;\n  padding: 5px 30px;\n  border-radius: 15px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.following-temp {\n  background: var(--bg-200);\n  color: white;\n  border: 1px var(--primary-200);\n  padding: 5px 30px;\n  border-radius: 15px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n\n.send-post-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(10, 10, 10, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.25s ease;\n}\n\n.send-post-share-modal {\n  width: 420px;\n  max-height: 80vh;\n  background: white;\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 20px;\n  /* color: white; */\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  animation: scaleIn 0.25s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.send-post-share-modal h3 {\n  text-align: center;\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.send-post-share-list {\n  overflow-y: auto;\n  max-height: 300px;\n  padding-right: 5px;\n}\n\n/* scrollbar clean */\n.send-post-share-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.send-post-share-list::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n}\n\n.send-post-share-item {\n  padding: 10px;\n  border-radius: 12px;\n  transition: 0.2s;\n  cursor: pointer;\n}\n\n.send-post-share-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.send-post-share-item input[type=\"checkbox\"] {\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 6px;\n  border: 2px solid #555;\n  margin-right: 10px;\n  cursor: pointer;\n  position: relative;\n  transition: 0.2s;\n}\n\n.send-post-share-item input[type=\"checkbox\"]:checked {\n  /* background: linear-gradient(135deg, #4facfe, #00f2fe); */\n  background: var(--primary-200);\n  border: none;\n}\n\n.send-post-share-item input[type=\"checkbox\"]:checked::after {\n  content: \"✓\";\n  color: white;\n  font-size: 12px;\n  position: absolute;\n  top: 1px;\n  left: 4px;\n}\n\n.send-post-share-item label {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.send-post-modal-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 15px;\n  gap: 10px;\n}\n\n.send-post-modal-actions button:first-child {\n  flex: 1;\n  background: transparent;\n  border: 1px solid #555;\n  color: var(--primary-200);\n  font-weight: bold;\n  padding: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.send-post-modal-actions button:first-child:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.send-post-modal-actions button:last-child {\n  flex: 1;\n  /* background: linear-gradient(135deg, #4facfe, #00f2fe); */\n  background: var(--primary-200);\n  border: none;\n  color: white;\n  font-weight: bold;\n  padding: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: 0.25s;\n}\n\n.send-post-modal-actions button:last-child:hover {\n  transform: scale(1.05);\n  box-shadow: 0 10px 20px rgba(0, 242, 254, 0.4);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n\n\n\n\n.publish-loading-bar {\n\n  position: fixed;\n\n  top: 0;\n  left: 0;\n\n  width: 100%;\n  height: 4px;\n\n  z-index: 99999;\n\n  background: #e5e7eb;\n\n}\n\n.publish-progress {\n\n  height: 100%;\n\n  width: 40%;\n\n  background: #4e7799;\n\n  animation:\n    loadingMove 1.2s linear infinite;\n\n}\n\n.publish-loading-bar span {\n\n  position: fixed;\n\n  top: 15px;\n\n  left: 50%;\n\n  transform:\n    translateX(-50%);\n\n  background: white;\n\n  padding: 10px 18px;\n\n  border-radius: 999px;\n\n  font-size: 14px;\n\n  font-weight: 600;\n\n  box-shadow:\n    0 8px 30px rgba(0, 0, 0, .1);\n\n}\n\n@keyframes loadingMove {\n\n  0% {\n\n    transform:\n      translateX(-100%);\n\n  }\n\n  100% {\n\n    transform:\n      translateX(300%);\n\n  }\n\n}\n\n\n.publish-toast {\n\n  position: fixed;\n\n  bottom: 30px;\n  left: 50%;\n\n  transform:\n    translateX(-50%);\n\n  background: white;\n\n  padding: 14px 20px;\n\n  border-radius: 18px;\n\n  display: flex;\n\n  align-items: center;\n\n  gap: 15px;\n\n  box-shadow:\n    0 10px 30px rgba(0, 0, 0, .15);\n\n  z-index: 99999;\n\n  animation:\n    toastUp .35s ease;\n\n}\n\n.publish-success-icon {\n\n  width: 45px;\n  height: 45px;\n\n  border-radius: 50%;\n\n  display: flex;\n\n  align-items: center;\n  justify-content: center;\n\n  background: #22c55e;\n\n  color: white;\n\n  font-size: 20px;\n\n  font-weight: bold;\n\n}\n\n@keyframes toastUp {\n\n  from {\n\n    opacity: 0;\n\n    transform:\n      translate(-50%,\n        30px);\n\n  }\n\n  to {\n\n    opacity: 1;\n\n    transform:\n      translate(-50%,\n        0);\n\n  }\n\n}\n\n\n.post-text{\n\n  white-space:pre-wrap;\n  word-break:break-word;\n  line-height:1.5;\n  margin:0;\n\n}\n\n.post-text.collapsed{\n\n  display:-webkit-box;\n  -webkit-box-orient:vertical;\n  -webkit-line-clamp:3;\n\n  overflow:hidden;\n\n}\n\n.post-text.expanded{\n\n  display:block;\n\n}\n\n.post-see-more{\n\n  margin-top:8px;\n\n  border:none;\n  background:none;\n\n  color:var(--primary-100);\n\n  font-weight:600;\n\n  cursor:pointer;\n\n  padding:0;\n\n}\n\n\n\n/* \n.post.modal-layout{\n  display:flex;\n  width:100%;\n  height:88vh;\n  max-width:1400px;\n  background:#fff;\n  border-radius:22px;\n  overflow:hidden;\n}\n\n\n\n.post-left-side .post-image,\n.post-left-side .post-video-container{\n  flex:1;\n  width:100%;\n  min-height:0;\n  background:black;\n}\n\n.post-left-side img,\n.post-left-side video{\n  width:100%;\n  height:100%;\n  object-fit:contain;\n}\n\n\n.post-right-side{\n  width:40%;\n  border-left:1px solid #eee;\n  display:flex;\n  flex-direction:column;\n  background:white;\n}\n\n\n\n.comment-panel{\n  position:relative !important;\n  inset:auto !important;\n  width:100% !important;\n  height:100%;\n  border-radius:0;\n  box-shadow:none;\n}\n\n\n\n.comment-list{\n  flex:1;\n  overflow-y:auto;\n}\n\n\n.comment-input{\n  position:sticky;\n  bottom:0;\n  background:white;\n  border-top:1px solid #eee;\n} */\n\n\n\n.share-success-toast {\n\n  position: fixed;\n\n  bottom: 30px;\n  left: 50%;\n\n  transform: translateX(-50%);\n\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  background: white;\n\n  padding: 14px 20px;\n\n  border-radius: 18px;\n\n  box-shadow:\n    0 10px 35px rgba(0, 0, 0, .15);\n\n  animation:\n    sharePopup .35s ease;\n\n  z-index: 999999;\n\n}\n\n.share-success-icon {\n\n  width: 42px;\n  height: 42px;\n\n  border-radius: 50%;\n\n  background: var(--primary-100);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: white;\n\n  font-weight: bold;\n  font-size: 18px;\n\n}\n\n.share-success-toast strong {\n\n  display: block;\n  font-size: 14px;\n\n}\n\n.share-success-toast p {\n\n  margin: 2px 0 0;\n  color: #777;\n  font-size: 12px;\n\n}\n\n@keyframes sharePopup {\n\n  from {\n\n    opacity: 0;\n\n    transform:\n      translate(-50%, 30px);\n\n  }\n\n  to {\n\n    opacity: 1;\n\n    transform:\n      translate(-50%, 0);\n\n  }\n\n}\n\n\n/* .post-user-icon{\n  color: var(--primary-200);\n} */\n\n/* Premium CarrerUp composer */\n.create-post {\n  position: relative;\n  align-items: center;\n  padding: 14px;\n  overflow: hidden;\n  background: rgba(250, 252, 253, .94);\n  border: 1px solid rgba(78, 119, 153, .17);\n  border-radius: 17px;\n  box-shadow: 0 14px 32px rgba(30, 63, 88, .09), inset 0 1px rgba(255, 255, 255, .95);\n}\n\n.create-post::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 22px;\n  left: 22px;\n  height: 1px;\n  background: rgba(233, 90, 19, .33);\n}\n\n.create-post img,\n.create-post > .post-user-icon,\n.create-post > .avatar {\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  width: 43px !important;\n  height: 43px !important;\n  padding: 2px;\n  border: 2px solid #fff;\n  border-radius: 13px !important;\n  color: #4e7799;\n  background: #eaf0f4;\n  box-shadow: 0 4px 12px rgba(30, 63, 88, .12);\n}\n\n.create-post textarea {\n  min-height: 46px;\n  padding: 12px 14px;\n  border: 1px solid transparent;\n  border-radius: 13px;\n  color: #29475e;\n  background: #eef3f6;\n  font-size: .88rem;\n  line-height: 1.35;\n  transition: .2s ease;\n}\n\n.create-post textarea::placeholder { color: #71899b; }\n\n.create-post textarea:focus {\n  border-color: rgba(233, 90, 19, .5);\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .08);\n}\n\n.create-post button {\n  min-height: 43px;\n  padding: 0 15px;\n  border: 1px solid #e95a13;\n  border-radius: 12px;\n  background: #e95a13;\n  box-shadow: 0 8px 18px rgba(233, 90, 19, .2);\n  font-size: .78rem;\n  font-weight: 750;\n  transition: .2s ease;\n}\n\n.create-post button:hover {\n  background: #d84f0d;\n  box-shadow: 0 11px 21px rgba(233, 90, 19, .28);\n  transform: translateY(-1px);\n}\n\n.post-options {\n  position: relative;\n  gap: 9px;\n  padding: 10px;\n  overflow: hidden;\n  background: rgba(250, 252, 253, .94);\n  border: 1px solid rgba(78, 119, 153, .15);\n  border-radius: 16px;\n  box-shadow: 0 12px 26px rgba(30, 63, 88, .07), inset 0 1px rgba(255, 255, 255, .92);\n}\n\n.post-options::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 28px;\n  left: 28px;\n  height: 1px;\n  background: rgba(78, 119, 153, .22);\n}\n\n.post-options button {\n  flex: 1 1 0;\n  justify-content: center;\n  gap: 7px;\n  min-height: 42px;\n  margin: 0;\n  padding: 8px 10px;\n  border: 1px solid transparent;\n  border-radius: 11px;\n  color: #4e7799;\n  background: #edf3f6;\n  cursor: pointer;\n  font-size: .78rem;\n  font-weight: 700;\n  transition: .2s ease;\n}\n\n.post-options button svg {\n  font-size: .95rem;\n  color: #4e7799;\n  transition: .2s ease;\n}\n\n.post-options button:hover {\n  border-color: rgba(233, 90, 19, .22);\n  color: #d84f0d;\n  background: #fff3ec;\n  box-shadow: 0 5px 13px rgba(30, 63, 88, .08);\n  transform: translateY(-2px);\n}\n\n.post-options button:hover svg { color: #e95a13; }\n\n@media (max-width: 944px) {\n  .create-post {\n    margin-bottom: 14px;\n    padding: 11px;\n    gap: 8px;\n  }\n\n  .create-post img,\n  .create-post > .post-user-icon,\n  .create-post > .avatar {\n    width: 39px !important;\n    height: 39px !important;\n  }\n\n  .create-post textarea {\n    min-width: 0;\n    padding: 10px 11px;\n    font-size: .8rem;\n  }\n\n  .create-post button {\n    padding: 0 11px;\n    font-size: .72rem;\n  }\n\n  .post-options {\n    gap: 6px;\n    padding: 8px;\n    margin-bottom: 14px;\n  }\n\n  .post-options button {\n    flex-direction: column;\n    gap: 3px;\n    min-height: 48px;\n    padding: 6px 4px;\n    font-size: .67rem;\n  }\n}\n\n/* Feed canvas — step 1: application surface and responsive reading column. */\n.dashboard-main.feed-canvas {\n  box-sizing: border-box;\n  padding: 92px 24px 48px !important;\n  background: #f4f7f8;\n}\n\n.feed-canvas .feed {\n  box-sizing: border-box;\n  width: min(100%, 680px);\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 0;\n}\n\n@media (max-width: 944px) {\n  .dashboard-main.feed-canvas {\n    padding: 86px 16px 96px !important;\n  }\n\n  .feed-canvas .feed {\n    width: min(100%, 640px);\n    max-width: 640px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-main.feed-canvas {\n    padding: 86px 12px 96px !important;\n  }\n\n  .feed-canvas .feed {\n    width: 100%;\n    max-width: none;\n    padding: 0;\n  }\n}\n\n/* Feed composer: one unified entry point above the publication stream. */\n.feed-composer {\n  position: relative;\n  margin-bottom: 26px;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid rgba(78, 119, 153, .18);\n  border-radius: 20px;\n  box-shadow: 0 16px 34px rgba(30, 63, 88, .09), inset 0 1px #ffffff;\n}\n\n.feed-composer::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 28px;\n  left: 28px;\n  height: 2px;\n  background: #e95a13;\n}\n\n.feed-composer .create-post {\n  margin: 0;\n  padding: 17px;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.feed-composer .create-post::before,\n.feed-composer .post-options::before {\n  display: none;\n}\n\n.feed-composer .post-options {\n  margin: 0;\n  padding: 10px 12px 12px;\n  background: transparent;\n  border: 0;\n  border-top: 1px solid rgba(78, 119, 153, .13);\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.feed-composer .post-options button {\n  min-height: 44px;\n  background: #f1f5f7;\n}\n\n.feed-composer .post-options button:hover {\n  background: #fff3ec;\n}\n\n@media (max-width: 944px) {\n  .feed-composer {\n    margin-bottom: 20px;\n    border-radius: 18px;\n  }\n\n  .feed-composer .create-post {\n    margin: 0;\n    padding: 12px;\n  }\n\n  .feed-composer .post-options {\n    margin: 0;\n    padding: 8px 10px 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .feed-composer {\n    margin-bottom: 18px;\n    border-radius: 16px;\n  }\n\n  .feed-composer::before {\n    right: 20px;\n    left: 20px;\n  }\n\n  .feed-composer .create-post {\n    padding: 11px;\n  }\n\n  .feed-composer .post-options {\n    padding: 8px;\n  }\n}\n\n/* Publication cards: clear hierarchy inspired by the validated feed direction. */\n.feed-canvas .post {\n  overflow: visible;\n  margin-bottom: 18px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 18px;\n  box-shadow: 0 10px 26px rgba(30, 63, 88, .06), inset 0 1px #ffffff;\n}\n\n.feed-canvas .post-header {\n  min-height: 48px;\n  gap: 14px;\n}\n\n.feed-canvas .post-header-left {\n  min-width: 0;\n  gap: 11px;\n}\n\n.feed-canvas .post-header img,\n.feed-canvas .post-header .post-user-icon {\n  display: grid;\n  flex: 0 0 auto;\n  place-items: center;\n  box-sizing: border-box;\n  width: 46px;\n  height: 46px;\n  padding: 2px;\n  object-fit: cover;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  color: #4e7799;\n  background: #eaf0f4;\n  box-shadow: 0 4px 12px rgba(30, 63, 88, .12);\n}\n\n.feed-canvas .post-user-info {\n  min-width: 0;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n}\n\n.feed-canvas .post-user-info b {\n  overflow: hidden;\n  max-width: 100%;\n  color: #1d394f;\n  font-size: .94rem;\n  font-weight: 750;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.feed-canvas .post-header-right {\n  margin-left: auto;\n  gap: 10px;\n}\n\n.feed-canvas .post-time {\n  display: inline-block;\n  color: #71899b;\n  font-size: .75rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.feed-canvas .post-menu-icon {\n  box-sizing: content-box;\n  padding: 8px;\n  border-radius: 10px;\n  color: #4e7799;\n  transition: .18s ease;\n}\n\n.feed-canvas .post-menu-icon:hover {\n  color: #e95a13;\n  background: #fff3ec;\n}\n\n.feed-canvas .follow-btn-post,\n.feed-canvas .following-temp {\n  padding: 7px 13px;\n  border-radius: 10px;\n  font-size: .72rem;\n  font-weight: 750;\n}\n\n.feed-canvas .follow-btn-post {\n  border: 1px solid rgba(233, 90, 19, .22);\n  color: #d84f0d;\n  background: #fff3ec;\n}\n\n.feed-canvas .post-text-wrapper {\n  margin: 16px 0 0;\n}\n\n.feed-canvas .post-text {\n  color: #345269;\n  font-size: .9rem;\n  line-height: 1.65;\n}\n\n.feed-canvas .post-see-more {\n  color: #e95a13;\n  font-size: .8rem;\n}\n\n.feed-canvas .post-image {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 5;\n  max-height: 520px;\n  margin-top: 16px;\n  object-fit: cover;\n  background: #eef3f6;\n  border: 1px solid rgba(78, 119, 153, .13);\n  border-radius: 14px;\n}\n\n.feed-canvas .post-video-container {\n  margin-top: 16px;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  background: #020617;\n  border: 1px solid rgba(78, 119, 153, .13);\n  border-radius: 14px;\n}\n\n.feed-canvas .post-video-container video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.feed-infinite-sentinel {\n  width: 100%;\n  height: 1px;\n  pointer-events: none;\n}\n\n.feed-canvas .post-link {\n  margin-top: 16px;\n  padding: 12px 14px;\n  overflow: hidden;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 12px;\n  color: #4e7799;\n  background: #f4f8fa;\n  font-size: .82rem;\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.feed-canvas .post-stats {\n  justify-content: flex-start;\n  gap: 16px;\n  margin-top: 15px;\n  padding: 0 3px 11px;\n  border-bottom: 1px solid rgba(78, 119, 153, .13);\n  color: #71899b;\n  font-size: .75rem;\n}\n\n.feed-canvas .post-actions {\n  position: relative;\n  justify-content: flex-start;\n  gap: 6px;\n  margin-top: 18px;\n  padding-top: 15px;\n  border: 0;\n}\n\n.feed-canvas .post-actions::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 1px;\n  background: rgba(78, 119, 153, .16);\n}\n\n.feed-canvas .post-actions::after {\n  content: \"\";\n  position: absolute;\n  top: -1px;\n  left: 0;\n  width: 52px;\n  height: 2px;\n  border-radius: 2px;\n  background: #e95a13;\n}\n\n.feed-canvas .post-actions button {\n  flex: 0 0 auto;\n  justify-content: center;\n  min-width: 52px;\n  min-height: 40px;\n  border-radius: 10px;\n  color: #4e7799;\n  font-size: .78rem;\n  font-weight: 700;\n  transition: .18s ease;\n}\n\n.feed-canvas .post-actions button svg {\n  font-size: 1rem;\n}\n\n.feed-canvas .post-action-count {\n  min-width: 1ch;\n  color: currentColor;\n  font-size: .76rem;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n}\n\n.feed-canvas .post-actions button:hover {\n  color: #d84f0d;\n  background: #fff3ec;\n}\n\n.feed-canvas .post-actions button.active {\n  color: #e95a13;\n  /* background: #fff3ec; */\n}\n\n@media (max-width: 944px) {\n  .feed-canvas .post {\n    margin-bottom: 15px;\n    padding: 14px;\n    border-radius: 16px;\n  }\n\n  .feed-canvas .post-image,\n  .feed-canvas .post-video-container {\n    margin-top: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .feed-canvas .post {\n    margin-bottom: 14px;\n    padding: 13px;\n    border-radius: 15px;\n  }\n\n  .feed-canvas .post-header {\n    gap: 9px;\n  }\n\n  .feed-canvas .post-header img,\n  .feed-canvas .post-header .post-user-icon {\n    width: 42px;\n    height: 42px;\n  }\n\n  .feed-canvas .post-user-info b {\n    font-size: .88rem;\n  }\n\n  .feed-canvas .post-time {\n    font-size: .68rem;\n  }\n\n  .feed-canvas .follow-btn-post,\n  .feed-canvas .following-temp {\n    padding: 6px 9px;\n    font-size: .66rem;\n  }\n\n  .feed-canvas .post-text-wrapper {\n    margin-top: 13px;\n  }\n\n  .feed-canvas .post-text {\n    font-size: .84rem;\n    line-height: 1.55;\n  }\n\n  .feed-canvas .post-image,\n  .feed-canvas .post-video-container {\n    margin-top: 13px;\n    border-radius: 12px;\n  }\n\n  .feed-canvas .post-stats {\n    gap: 10px;\n    margin-top: 13px;\n    padding-bottom: 9px;\n    font-size: .68rem;\n  }\n\n  .feed-canvas .post-actions {\n    gap: 3px;\n    margin-top: 15px;\n    padding-top: 12px;\n  }\n\n  .feed-canvas .post-actions button {\n    gap: 5px;\n    min-height: 38px;\n    padding: 6px 4px;\n  }\n\n  .feed-canvas .post-action-count {\n    font-size: .7rem;\n  }\n}\n\n/* Desktop feed panels: supplementary navigation stays outside the reading flow. */\n.feed-layout {\n  display: block;\n}\n\n.feed-sidebar {\n  display: none;\n}\n\n.feed-mobile-sections {\n  display: none;\n}\n\n@media (min-width: 1150px) {\n  .feed-canvas .feed {\n    width: min(100%, 1240px);\n    max-width: 1240px;\n  }\n\n  .feed-layout {\n    display: grid;\n    grid-template-columns: 190px minmax(0, 680px) 250px;\n    gap: 18px;\n    align-items: start;\n  }\n\n  .feed-stream {\n    grid-column: 2;\n    min-width: 0;\n  }\n\n  .feed-sidebar {\n    position: fixed;\n    z-index: 10;\n    top: 88px;\n    align-self: start;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    max-height: calc(100vh - 104px);\n    max-height: calc(100dvh - 104px);\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(78, 119, 153, .3) transparent;\n  }\n\n  .feed-sidebar-left {\n    left: max(24px, calc((100vw - 1240px) / 2));\n    width: 190px;\n  }\n\n  .feed-sidebar-right {\n    right: max(24px, calc((100vw - 1240px) / 2));\n    width: 250px;\n  }\n\n  .feed-sidebar::-webkit-scrollbar {\n    width: 5px;\n  }\n\n  .feed-sidebar::-webkit-scrollbar-thumb {\n    background: rgba(78, 119, 153, .3);\n    border-radius: 999px;\n  }\n\n  .feed-side-panel {\n    padding: 14px;\n    background: #ffffff;\n    border: 1px solid rgba(78, 119, 153, .16);\n    border-radius: 16px;\n    box-shadow: 0 10px 24px rgba(30, 63, 88, .05), inset 0 1px #ffffff;\n  }\n\n  .feed-side-kicker {\n    margin: 0 0 10px;\n    color: #345269;\n    font-size: .75rem;\n    font-weight: 800;\n    letter-spacing: .06em;\n    text-transform: uppercase;\n  }\n\n  .feed-career-pulse-panel {\n    position: relative;\n    overflow: hidden;\n    padding: 16px 14px 14px;\n  }\n\n  .feed-career-pulse-panel::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 18px;\n    left: 18px;\n    height: 2px;\n    background: #e95a13;\n  }\n\n  .feed-pulse-heading {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    margin-bottom: 13px;\n  }\n\n  .feed-pulse-icon,\n  .feed-pulse-metric-icon {\n    display: grid;\n    flex: 0 0 auto;\n    place-items: center;\n    color: #e95a13;\n    background: #fff2ea;\n    border: 1px solid #ffd7c2;\n  }\n\n  .feed-pulse-icon {\n    width: 31px;\n    height: 31px;\n    border-radius: 10px;\n    font-size: .85rem;\n  }\n\n  .feed-pulse-heading .feed-side-kicker {\n    margin: 0 0 2px;\n  }\n\n  .feed-pulse-heading small {\n    color: #71899b;\n    font-size: .65rem;\n    font-weight: 650;\n  }\n\n  .feed-pulse-metric {\n    display: grid;\n    grid-template-columns: 25px minmax(0, 1fr);\n    gap: 8px;\n    align-items: center;\n    padding: 9px 0;\n    border-top: 1px solid rgba(78, 119, 153, .11);\n  }\n\n  .feed-pulse-metric-icon {\n    width: 25px;\n    height: 25px;\n    border-radius: 8px;\n    color: #4e7799;\n    background: #eef4f7;\n    border-color: #dce8ee;\n    font-size: .7rem;\n  }\n\n  .feed-pulse-metric small,\n  .feed-pulse-metric strong,\n  .feed-pulse-metric em {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .feed-pulse-metric small {\n    margin-bottom: 2px;\n    color: #71899b;\n    font-size: .63rem;\n    font-weight: 650;\n  }\n\n  .feed-pulse-metric strong {\n    color: #29475e;\n    font-size: .7rem;\n    font-weight: 800;\n  }\n\n  .feed-pulse-metric em {\n    margin-top: 2px;\n    color: #4e7799;\n    font-size: .62rem;\n    font-style: normal;\n    font-weight: 650;\n  }\n\n  .feed-pulse-opportunity .feed-pulse-metric-icon {\n    color: #e95a13;\n    background: #fff7f2;\n    border-color: #ffd9c5;\n  }\n\n  .feed-pulse-progress {\n    margin-top: 4px;\n    padding-top: 11px;\n    border-top: 1px solid rgba(78, 119, 153, .13);\n  }\n\n  .feed-pulse-progress-label {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 7px;\n    color: #71899b;\n    font-size: .65rem;\n    font-weight: 700;\n  }\n\n  .feed-pulse-progress-label strong { color: #e95a13; font-size: .7rem; }\n\n  .feed-pulse-progress-track {\n    display: block;\n    height: 5px;\n    overflow: hidden;\n    background: #eaf0f3;\n    border-radius: 999px;\n  }\n\n  .feed-pulse-progress-track span {\n    display: block;\n    height: 100%;\n    min-width: 5px;\n    background: #e95a13;\n    border-radius: inherit;\n    transition: width .35s ease;\n  }\n\n  .feed-quick-link {\n    display: grid;\n    grid-template-columns: 28px minmax(0, 1fr) 14px;\n    align-items: center;\n    width: 100%;\n    min-height: 42px;\n    padding: 8px 7px;\n    border: 0;\n    border-radius: 10px;\n    color: #345269;\n    background: transparent;\n    cursor: pointer;\n    font-size: .78rem;\n    font-weight: 700;\n    text-align: left;\n    transition: .18s ease;\n  }\n\n  .feed-quick-link > svg:first-child {\n    color: #4e7799;\n    font-size: .94rem;\n  }\n\n  .feed-quick-link > svg:last-child {\n    color: #94a9ba;\n    font-size: .65rem;\n  }\n\n  .feed-quick-link:hover {\n    color: #d84f0d;\n    background: #fff3ec;\n  }\n\n  .feed-quick-link:hover > svg:first-child,\n  .feed-quick-link:hover > svg:last-child {\n    color: #e95a13;\n  }\n\n  .feed-suggestions-panel .suggested-card {\n    gap: 8px;\n    margin: 0;\n    padding: 10px 0;\n    border: 0;\n    border-bottom: 1px solid rgba(78, 119, 153, .12);\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .feed-suggestions-panel .suggested-card:last-child {\n    padding-bottom: 0;\n    border-bottom: 0;\n  }\n\n  .feed-suggestions-panel .suggested-card:hover {\n    transform: none;\n    box-shadow: none;\n  }\n\n  .feed-suggestions-panel .suggested-header {\n    display: none;\n  }\n\n  .feed-suggestions-panel .suggested-body {\n    gap: 9px;\n  }\n\n  .feed-suggestions-panel .avatar {\n    /* width: 38px; */\n    /* height: 38px; */\n    border: 1px solid rgba(78, 119, 153, .15);\n  }\n\n  .feed-suggestions-panel .avatar-placeholder {\n    color: #4e7799;\n    background: #edf3f6;\n    font-size: .85rem;\n  }\n\n  .feed-suggestions-panel .info h4 {\n    color: #29475e;\n    font-size: .75rem;\n  }\n\n  .feed-suggestions-panel .info p {\n    overflow: hidden;\n    margin: 1px 0;\n    color: #71899b;\n    font-size: .66rem;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .feed-suggestions-panel .suggested-actions {\n    gap: 6px;\n    margin-top: 0;\n  }\n\n  .feed-suggestions-panel .suggested-actions button {\n    min-height: 30px;\n    padding: 5px 6px;\n    border: 1px solid rgba(78, 119, 153, .13);\n    border-radius: 8px;\n    font-size: .62rem;\n  }\n\n  .feed-suggestions-panel .suggested-actions .like {\n    color: #d84f0d;\n    background: #fff3ec;\n  }\n\n  .feed-role-panel {\n    position: relative;\n    overflow: hidden;\n    padding: 18px 14px 14px;\n  }\n\n  .feed-role-panel::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 22px;\n    left: 22px;\n    height: 2px;\n    background: #e95a13;\n  }\n\n  .feed-role-icon {\n    margin-bottom: 10px;\n    padding: 9px;\n    border-radius: 11px;\n    color: #e95a13;\n    background: #fff3ec;\n    font-size: 1.15rem;\n  }\n\n  .feed-role-panel h3 {\n    margin: 0 0 6px;\n    color: #29475e;\n    font-size: .9rem;\n  }\n\n  .feed-role-panel p {\n    margin: 0 0 13px;\n    color: #71899b;\n    font-size: .72rem;\n    line-height: 1.5;\n  }\n\n  .feed-role-panel button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    min-height: 36px;\n    padding: 8px 10px;\n    border: 1px solid #e95a13;\n    border-radius: 9px;\n    color: #ffffff;\n    background: #e95a13;\n    cursor: pointer;\n    font-size: .68rem;\n    font-weight: 750;\n    transition: .18s ease;\n  }\n\n  .feed-role-panel button:hover {\n    background: #d84f0d;\n    transform: translateY(-1px);\n  }\n}\n\n@media (max-width: 944px) {\n  .feed-mobile-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin: 0 0 16px;\n  }\n\n  .feed-mobile-role {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 10px;\n    padding: 12px;\n    background: #ffffff;\n    border: 1px solid rgba(78, 119, 153, .16);\n    border-radius: 15px;\n    box-shadow: 0 8px 20px rgba(30, 63, 88, .05);\n  }\n\n  .feed-mobile-role .feed-role-icon {\n    margin: 0;\n    padding: 8px;\n    border-radius: 10px;\n    color: #e95a13;\n    background: #fff3ec;\n    font-size: 1rem;\n  }\n\n  .feed-mobile-role h3 {\n    margin: 0 0 2px;\n    color: #29475e;\n    font-size: .78rem;\n  }\n\n  .feed-mobile-role p {\n    margin: 0;\n    color: #71899b;\n    font-size: .66rem;\n    line-height: 1.35;\n  }\n\n  .feed-mobile-role button {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    min-height: 32px;\n    padding: 6px 8px;\n    border: 1px solid #e95a13;\n    border-radius: 8px;\n    color: #ffffff;\n    background: #e95a13;\n    cursor: pointer;\n    font-size: .66rem;\n    font-weight: 750;\n  }\n\n}\n\n@media (min-width: 769px) and (max-width: 944px) {\n  .feed-mobile-sections {\n    margin-bottom: 20px;\n  }\n\n  .feed-mobile-role {\n    padding: 14px 16px;\n  }\n\n  .feed-mobile-role h3 {\n    font-size: .84rem;\n  }\n\n  .feed-mobile-role p {\n    font-size: .72rem;\n  }\n\n  .feed-mobile-role button {\n    min-height: 36px;\n    padding: 7px 11px;\n    font-size: .7rem;\n  }\n\n  .feed-canvas .post-actions button {\n    min-height: 41px;\n    padding: 7px 9px;\n  }\n}\n\n/* Final interaction polish. */\n.feed-canvas button:focus-visible,\n.feed-canvas a:focus-visible {\n  outline: 2px solid #e95a13;\n  outline-offset: 2px;\n}\n\n.feed-mobile-role button {\n  transition: .18s ease;\n}\n\n.feed-mobile-role button:hover {\n  background: #d84f0d;\n  transform: translateY(-1px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .feed-canvas *,\n  .feed-canvas *::before,\n  .feed-canvas *::after {\n    scroll-behavior: auto !important;\n    transition-duration: .01ms !important;\n    animation-duration: .01ms !important;\n    animation-iteration-count: 1 !important;\n  }\n}\n\n/* Feed typography: a crisp, professional sports-network voice. */\n.feed-canvas {\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  color: #1d394f;\n  letter-spacing: .003em;\n}\n\n.feed-canvas button,\n.feed-canvas input,\n.feed-canvas textarea {\n  font-family: inherit;\n}\n\n.feed-canvas .create-post textarea {\n  font-size: .92rem;\n  font-weight: 500;\n  letter-spacing: .005em;\n}\n\n.feed-canvas .create-post button,\n.feed-canvas .post-options button,\n.feed-canvas .feed-role-panel button,\n.feed-canvas .feed-mobile-role button {\n  letter-spacing: .015em;\n  font-weight: 800;\n}\n\n.feed-canvas .post-user-info b {\n  font-size: .98rem;\n  /* font-weight: 800; */\n  letter-spacing: -.012em;\n}\n\n.feed-canvas .post-time {\n  font-size: .74rem;\n  font-weight: 600;\n  letter-spacing: .01em;\n}\n\n.feed-canvas .post-text {\n  color: #29475e;\n  font-size: .94rem;\n  font-weight: 450;\n  letter-spacing: .006em;\n  line-height: 1.68;\n}\n\n.feed-canvas .post-link {\n  font-weight: 700;\n  letter-spacing: .01em;\n}\n\n.feed-canvas .post-action-count {\n  font-size: .78rem;\n  font-weight: 750;\n}\n\n.feed-canvas .feed-side-kicker {\n  font-size: .7rem;\n  font-weight: 850;\n  letter-spacing: .09em;\n}\n\n.feed-canvas .feed-quick-link {\n  font-size: .8rem;\n  font-weight: 750;\n  letter-spacing: .008em;\n}\n\n.feed-canvas .feed-role-panel h3,\n.feed-canvas .feed-mobile-role h3 {\n  font-weight: 850;\n  letter-spacing: -.012em;\n}\n\n.feed-canvas .feed-role-panel p,\n.feed-canvas .feed-mobile-role p {\n  font-weight: 500;\n  letter-spacing: .008em;\n}\n\n@media (max-width: 768px) {\n  .feed-canvas .create-post textarea {\n    font-size: .84rem;\n  }\n\n  .feed-canvas .post-user-info b {\n    font-size: .91rem;\n  }\n\n  .feed-canvas .post-text {\n    font-size: .87rem;\n    line-height: 1.62;\n  }\n}\n\n/* Post, video and link modals: bright high-tech CarrerUp treatment. */\n.modal-overlay {\n  padding: 20px;\n  background: rgba(20, 43, 61, .48);\n  backdrop-filter: blur(12px);\n}\n\n.modal-overlay > .modal {\n  position: relative;\n  box-sizing: border-box;\n  width: min(100%, 470px);\n  max-height: min(88vh, 720px);\n  overflow-y: auto;\n  padding: 24px;\n  border: 1px solid rgba(148, 169, 186, .42);\n  border-radius: 22px;\n  color: #1d394f;\n  background: #fbfcfd;\n  box-shadow: 0 28px 75px rgba(12, 31, 47, .32), inset 0 1px #ffffff;\n  animation: feed-modal-in .24s ease-out;\n}\n\n.modal-overlay > .modal::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 34px;\n  left: 34px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #e95a13;\n}\n\n.modal-overlay > .modal h3 {\n  margin: 4px 0 20px;\n  color: #1d394f;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: 1.1rem;\n  font-weight: 850;\n  letter-spacing: -.01em;\n}\n\n.modal-overlay > .modal input,\n.modal-overlay > .modal textarea {\n  box-sizing: border-box;\n  margin-bottom: 14px;\n  padding: 13px 14px;\n  border: 1px solid rgba(78, 119, 153, .2);\n  border-radius: 12px;\n  color: #29475e;\n  background: #f1f5f7;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .88rem;\n  transition: .18s ease;\n}\n\n.modal-overlay > .modal input:focus,\n.modal-overlay > .modal textarea:focus {\n  border-color: #e95a13;\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.modal-overlay > .modal .image-upload {\n  margin-bottom: 16px;\n  border: 1px dashed rgba(78, 119, 153, .42);\n  border-radius: 14px;\n  background: #f4f8fa;\n}\n\n.modal-overlay > .modal .image-upload:hover {\n  border-color: #e95a13;\n  background: #fff8f4;\n}\n\n.modal-overlay > .modal .image-placeholder {\n  color: #4e7799;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .85rem;\n  font-weight: 700;\n}\n\n.modal-overlay > .modal .image-placeholder .camera,\n.modal-overlay > .modal .image-placeholder > svg {\n  color: #e95a13;\n}\n\n.modal-overlay > .modal .modal-actions {\n  gap: 9px;\n  padding-top: 4px;\n}\n\n.modal-overlay > .modal .modal-actions button {\n  min-height: 42px;\n  padding: 9px 15px;\n  border-radius: 11px;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .78rem;\n  font-weight: 800;\n  transition: .18s ease;\n}\n\n.modal-overlay > .modal .modal-actions .cancel {\n  border: 1px solid rgba(78, 119, 153, .22);\n  color: #4e7799;\n  background: #f1f5f7;\n}\n\n.modal-overlay > .modal .modal-actions .cancel:hover {\n  color: #29475e;\n  background: #e6eef2;\n}\n\n.modal-overlay > .modal .modal-actions .publish {\n  border: 1px solid #e95a13;\n  background: #e95a13;\n  box-shadow: 0 8px 18px rgba(233, 90, 19, .2);\n}\n\n.modal-overlay > .modal .modal-actions .publish:hover {\n  background: #d84f0d;\n  transform: translateY(-1px);\n}\n\n@keyframes feed-modal-in {\n  from { opacity: 0; transform: translateY(12px) scale(.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@media (max-width: 768px) {\n  .modal-overlay {\n    align-items: flex-end;\n    padding: 10px;\n  }\n\n  .modal-overlay > .modal {\n    width: 100%;\n    max-height: 84vh;\n    padding: 20px 16px;\n    border-radius: 18px;\n  }\n}\n\n/* Creation modals — premium high-tech editorial surface. */\n.modal-overlay > .modal {\n  width: min(100%, 520px);\n  padding: 22px;\n}\n\n.feed-modal-header {\n  display: grid;\n  grid-template-columns: 46px minmax(0, 1fr) 34px;\n  align-items: start;\n  gap: 12px;\n  margin: 4px 0 20px;\n}\n\n.feed-modal-icon {\n  display: grid;\n  width: 46px;\n  height: 46px;\n  place-items: center;\n  color: #e95a13;\n  background: #fff5ef;\n  border: 1px solid #ffd4bd;\n  border-radius: 14px;\n  box-shadow: 0 7px 16px rgba(30, 63, 88, .08);\n  font-size: 1.1rem;\n}\n\n.modal-overlay > .modal .feed-modal-header h3 {\n  margin: 2px 0 4px;\n  font-size: 1.06rem;\n}\n\n.feed-modal-header p {\n  margin: 0;\n  color: #71899b;\n  font-size: .76rem;\n  font-weight: 550;\n  line-height: 1.45;\n}\n\n.feed-modal-close {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  place-items: center;\n  border: 1px solid #dfe9ee;\n  border-radius: 10px;\n  color: #4e7799;\n  background: #f5f8fa;\n  cursor: pointer;\n  transition: .18s ease;\n}\n\n.feed-modal-close:hover {\n  color: #e95a13;\n  background: #fff3ec;\n  border-color: #ffc9aa;\n}\n\n.feed-modal-fields > input {\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.modal-overlay > .modal .feed-modal-upload {\n  position: relative;\n  min-height: 172px;\n  margin: 0 0 13px;\n  aspect-ratio: auto;\n  border: 1px dashed #9bb2c2;\n  border-radius: 14px;\n  background: #f7fafb;\n}\n\n.modal-overlay > .modal .feed-modal-upload:hover {\n  border-color: #e95a13;\n  background: #fff8f4;\n}\n\n.modal-overlay > .modal .feed-modal-upload.has-media {\n  min-height: 220px;\n  border-style: solid;\n  border-color: #d6e2e9;\n  background: #eef3f6;\n}\n\n.feed-modal-cropper {\n  position: relative;\n  width: 100%;\n  height: 280px;\n}\n\n.modal-overlay > .modal .feed-modal-upload video {\n  display: block;\n  width: 100%;\n  max-height: 300px;\n  object-fit: cover;\n}\n\n.modal-overlay > .modal .feed-modal-upload .image-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 7px;\n  padding: 22px;\n  color: #4e7799;\n}\n\n.modal-overlay > .modal .feed-modal-upload .image-placeholder > svg,\n.modal-overlay > .modal .feed-modal-upload .image-placeholder .camera {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  margin: 0 0 2px;\n  place-items: center;\n  border-radius: 12px;\n  color: #e95a13;\n  background: #fff0e8;\n  font-size: 1rem;\n}\n\n.modal-overlay > .modal .feed-modal-upload .image-placeholder strong {\n  color: #345269;\n  font-size: .8rem;\n  font-weight: 800;\n}\n\n.modal-overlay > .modal .feed-modal-upload .image-placeholder small,\n.feed-modal-hint {\n  color: #71899b;\n  font-size: .7rem;\n  font-weight: 600;\n}\n\n.feed-modal-hint {\n  margin: -2px 0 14px;\n  line-height: 1.45;\n}\n\n.feed-modal-error {\n  margin: -4px 0 12px;\n  padding: 9px 11px;\n  border: 1px solid #ffcbb2;\n  border-radius: 10px;\n  color: #b73f09;\n  background: #fff4ee;\n  font-size: .74rem;\n  font-weight: 700;\n}\n\n.modal-overlay > .modal .modal-actions {\n  justify-content: stretch;\n  margin-top: 2px;\n  padding-top: 12px;\n  border-top: 1px solid #e4edf1;\n}\n\n.modal-overlay > .modal .modal-actions button {\n  display: inline-flex;\n  flex: 1 1 0;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n}\n\n@media (max-width: 768px) {\n  .modal-overlay > .modal { padding: 19px 15px; }\n\n  .feed-modal-header {\n    grid-template-columns: 42px minmax(0, 1fr) 32px;\n    gap: 10px;\n    margin-bottom: 17px;\n  }\n\n  .feed-modal-icon { width: 42px; height: 42px; border-radius: 12px; }\n  .feed-modal-cropper { height: 245px; }\n  .modal-overlay > .modal .feed-modal-upload.has-media { min-height: 205px; }\n}\n\n/* Share modal — CarrerUp high-tech delivery panel. */\n.send-post-modal-overlay {\n  padding: 20px;\n  background: rgba(20, 43, 61, .52);\n}\n\n.send-post-share-modal {\n  position: relative;\n  box-sizing: border-box;\n  width: min(100%, 460px);\n  max-height: min(82vh, 640px);\n  padding: 21px;\n  border: 1px solid rgba(148, 169, 186, .42);\n  border-radius: 20px;\n  color: #1d394f;\n  background: #fbfcfd;\n  box-shadow: 0 28px 75px rgba(12, 31, 47, .3), inset 0 1px #ffffff;\n}\n\n.send-post-share-modal::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 32px;\n  left: 32px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #e95a13;\n}\n\n.send-post-share-header {\n  display: grid;\n  grid-template-columns: 42px minmax(0, 1fr) 32px;\n  gap: 11px;\n  align-items: start;\n  margin: 4px 0 17px;\n}\n\n.send-post-share-header > span {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  place-items: center;\n  border: 1px solid #ffd5bf;\n  border-radius: 13px;\n  color: #e95a13;\n  background: #fff4ed;\n  font-size: 1rem;\n}\n\n.send-post-share-modal .send-post-share-header h3 {\n  margin: 2px 0 4px;\n  color: #1d394f;\n  font-size: 1rem;\n  font-weight: 850;\n  text-align: left;\n}\n\n.send-post-share-header p {\n  margin: 0;\n  color: #71899b;\n  font-size: .73rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.send-post-share-close {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  place-items: center;\n  border: 1px solid #dfe9ee;\n  border-radius: 9px;\n  color: #4e7799;\n  background: #f5f8fa;\n  cursor: pointer;\n  transition: .18s ease;\n}\n\n.send-post-share-close:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }\n\n.send-post-share-list {\n  max-height: 315px;\n  padding: 4px;\n  border: 1px solid #e1ebf0;\n  border-radius: 13px;\n  background: #f7fafb;\n}\n\n.send-post-share-list::-webkit-scrollbar-thumb { background: #94a9ba; }\n\n.send-post-share-item {\n  margin: 2px 0;\n  padding: 8px;\n  border-radius: 10px;\n  color: #345269;\n  background: transparent;\n}\n\n.send-post-share-item:hover { background: #fff3ec; }\n\n.send-post-share-item label { gap: 2px; color: #345269; font-size: .78rem; font-weight: 750; }\n\n.send-post-share-item input[type=\"checkbox\"] {\n  width: 17px;\n  height: 17px;\n  margin-right: 9px;\n  border: 1px solid #9fb4c2;\n  border-radius: 6px;\n  background: #ffffff;\n}\n\n.send-post-share-item input[type=\"checkbox\"]:checked { background: #e95a13; border-color: #e95a13; }\n.send-post-share-item input[type=\"checkbox\"]:checked::after { top: 0; left: 3px; }\n\n.send-post-share-error {\n  margin: 10px 0 -2px;\n  padding: 9px 11px;\n  border: 1px solid #ffcbb2;\n  border-radius: 10px;\n  color: #b73f09;\n  background: #fff4ee;\n  font-size: .74rem;\n  font-weight: 750;\n}\n\n.send-post-modal-actions {\n  margin-top: 15px;\n  padding-top: 13px;\n  border-top: 1px solid #e3ecef;\n}\n\n.send-post-modal-actions button:first-child,\n.send-post-modal-actions button:last-child {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 41px;\n  padding: 8px 13px;\n  border-radius: 10px;\n  font-size: .76rem;\n  font-weight: 850;\n}\n\n.send-post-modal-actions button:first-child { border: 1px solid #dbe6ec; color: #4e7799; background: #f3f7f9; }\n.send-post-modal-actions button:last-child { border: 1px solid #e95a13; color: #ffffff; background: #e95a13; box-shadow: 0 7px 16px rgba(233, 90, 19, .18); }\n.send-post-modal-actions button:last-child:hover { background: #d84f0d; transform: translateY(-1px); }\n\n@media (max-width: 768px) {\n  .send-post-modal-overlay {\n    position: fixed;\n    inset: 0;\n    width: auto;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n    padding: 14px max(14px, env(safe-area-inset-right)) 14px max(14px, env(safe-area-inset-left));\n  }\n\n  .send-post-share-modal {\n    width: min(100%, 440px);\n    margin: 0;\n    transform: none;\n    max-height: min(68svh, 560px);\n    padding: 17px 13px 13px;\n    border-radius: 18px;\n  }\n\n  .send-post-share-modal::before { right: 22px; left: 22px; }\n\n  .send-post-share-header {\n    grid-template-columns: 39px minmax(0, 1fr) 31px;\n    gap: 9px;\n    margin: 2px 1px 13px;\n  }\n\n  .send-post-share-header > span { width: 39px; height: 39px; border-radius: 12px; font-size: .9rem; }\n  .send-post-share-modal .send-post-share-header h3 { margin-top: 1px; font-size: .92rem; }\n  .send-post-share-header p { font-size: .68rem; line-height: 1.35; }\n  .send-post-share-close { width: 31px; height: 31px; }\n\n  .send-post-share-list {\n    max-height: min(32svh, 260px);\n    min-height: 0;\n    padding: 3px;\n    border-radius: 12px;\n  }\n\n  .send-post-share-item { min-height: 38px; padding: 6px 8px; }\n  .send-post-share-item label { font-size: .74rem; }\n\n  .send-post-share-error { margin: 8px 0 -2px; padding: 8px 10px; font-size: .7rem; }\n\n  .send-post-modal-actions {\n    position: static;\n    margin: 11px -13px -13px;\n    padding: 11px 13px calc(11px + env(safe-area-inset-bottom));\n    background: #fbfcfd;\n  }\n\n  .send-post-modal-actions button:first-child,\n  .send-post-modal-actions button:last-child {\n    min-height: 42px;\n    padding: 8px 10px;\n    font-size: .73rem;\n  }\n}\n\n/* Comments — CarrerUp premium high-tech conversation layer. */\n.comment-panel,\n.viewer-comment-panel {\n  color: #29475e;\n  background: #fbfcfd;\n}\n\n.comment-header {\n  position: relative;\n  min-height: 48px;\n  padding: 13px 15px;\n  align-items: center;\n  border-bottom: 1px solid #e1ebf0;\n  color: #1d394f;\n  background: #ffffff;\n}\n\n.comment-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 22px;\n  left: 22px;\n  height: 2px;\n  background: #e95a13;\n}\n\n.comments-title { font-size: .83rem; font-weight: 850; letter-spacing: -.01em; }\n\n.close-comments-btn {\n  width: 31px;\n  height: 31px;\n  border: 1px solid #dce7ed;\n  border-radius: 9px;\n  color: #4e7799;\n  background: #f5f8fa;\n  font-size: 1rem;\n}\n\n.close-comments-btn:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; transform: none; }\n\n.comment-list {\n  padding: 11px;\n  background: #fbfcfd;\n  scrollbar-color: #94a9ba transparent;\n}\n\n.comment-item {\n  gap: 9px;\n  margin: 0;\n  padding: 11px 2px;\n  border-bottom: 1px solid #e8eff2;\n}\n\n.comment-item:not(:last-child) { border-bottom-color: #e8eff2; }\n.comment-left { min-width: 0; }\n\n.comment-top { gap: 6px; min-width: 0; }\n.comment-top b,\n.reply-content b { overflow: hidden; color: #29475e; font-size: .76rem; font-weight: 850; text-overflow: ellipsis; white-space: nowrap; }\n\n.comment-date { color: #94a9ba; font-size: .63rem; font-weight: 650; white-space: nowrap; }\n\n.comment-left > p,\n.reply-item > p { margin: 5px 0 0; color: #426076; font-size: .78rem; line-height: 1.52; word-break: break-word; }\n\n.pin-badge {\n  margin-left: 0;\n  padding: 3px 6px;\n  border: 1px solid #ffd9c5;\n  border-radius: 7px;\n  color: #d84f0d;\n  background: #fff6f1;\n  font-size: .59rem;\n  font-weight: 800;\n}\n\n.comment-bottom-actions,\n.reply-actions-row { gap: 4px; margin-top: 7px; flex-wrap: wrap; }\n\n.comment-bottom-actions button,\n.reply-actions-row button {\n  margin: 0;\n  padding: 3px 6px;\n  border: 0;\n  border-radius: 7px;\n  color: #71899b;\n  background: transparent;\n  font-size: .64rem;\n  font-weight: 750;\n}\n\n.comment-bottom-actions button:hover,\n.reply-actions-row button:hover { color: #e95a13; background: #fff3ec; transform: none; }\n.comment-bottom-actions .delete-comment { color: #c14b21; }\n\n.comment-like-section { min-width: 31px; padding-top: 1px; }\n\n.like-comment {\n  display: grid;\n  width: 29px;\n  height: 29px;\n  padding: 0;\n  place-items: center;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  color: #71899b;\n}\n\n.like-comment:hover { color: #e95a13; background: #fff3ec; transform: none; }\n.like-comment.liked { color: #e95a13; background: #fff3ec; }\n.like-count { color: #71899b; font-size: .62rem; font-weight: 750; }\n\n.replies-container {\n  margin-top: 9px;\n  padding: 2px 0 0 11px;\n  border-left: 1px solid #cddde5;\n  gap: 7px;\n}\n\n.reply-item {\n  padding: 7px 35px 7px 9px;\n  border: 1px solid #e5edf1;\n  border-radius: 10px;\n  background: #f5f8fa;\n}\n\n.reply-content { gap: 5px; align-items: center; }\n.reply-item .comment-like-section { top: 6px; right: 3px; }\n.reply-item .comment-like-section .like-comment { width: 25px; height: 25px; }\n.reply-item .comment-like-section .like-count { display: none; }\n\n/* Energetic like feedback shared by feed posts. */\n.post-actions .post-like-btn,\n.pv-like-btn {\n  position: relative;\n  isolation: isolate;\n  overflow: visible;\n}\n\n.modal-overlay > .modal .feed-caption-textarea {\n  display: block;\n  width: 100%;\n  min-height: 104px;\n  max-height: 190px;\n  resize: vertical;\n  overflow-y: auto;\n  line-height: 1.5;\n  scrollbar-width: thin;\n  scrollbar-color: #94a9ba transparent;\n}\n\n.modal-overlay > .modal .feed-caption-textarea::-webkit-scrollbar {\n  width: 5px;\n}\n\n.modal-overlay > .modal .feed-caption-textarea::-webkit-scrollbar-thumb {\n  border-radius: 99px;\n  background: #94a9ba;\n}\n\n@media (max-width: 600px) {\n  .modal-overlay > .modal .feed-caption-textarea {\n    min-height: 118px;\n    max-height: 32dvh;\n    resize: none;\n    font-size: 16px;\n  }\n}\n.post-actions .post-like-btn.just-liked svg,\n.pv-like-btn.just-liked svg {\n  color: #e95a13;\n  animation: postLikeHeartWow .72s cubic-bezier(.18,.89,.32,1.5) both;\n  filter: drop-shadow(0 5px 8px rgba(233,90,19,.32));\n}\n.post-actions .post-like-btn.just-liked::before,\n.pv-like-btn.just-liked::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  width: 30px;\n  height: 30px;\n  border: 2px solid rgba(233,90,19,.58);\n  border-radius: 50%;\n  animation: postLikeShockwave .72s ease-out both;\n}\n.post-actions .post-like-btn.just-liked::after,\n.pv-like-btn.just-liked::after {\n  content: \"✦\";\n  position: absolute;\n  top: -9px;\n  right: 2px;\n  color: #e95a13;\n  font-size: 11px;\n  text-shadow: -19px 14px #e0946e, 2px 27px #e95a13, 22px 14px #f3a477;\n  pointer-events: none;\n  animation: postLikeParticles .78s ease-out both;\n}\n@keyframes postLikeHeartWow {\n  0% { transform: scale(.45) rotate(-24deg); }\n  42% { transform: scale(1.65) rotate(13deg); }\n  68% { transform: scale(.88) rotate(-7deg); }\n  100% { transform: scale(1.08) rotate(0); }\n}\n@keyframes postLikeShockwave {\n  from { opacity: .9; transform: scale(.35); }\n  to { opacity: 0; transform: scale(2.15); }\n}\n@keyframes postLikeParticles {\n  0% { opacity: 0; transform: scale(.3) rotate(-15deg); }\n  35% { opacity: 1; }\n  100% { opacity: 0; transform: translateY(-13px) scale(1.3) rotate(18deg); }\n}\n\n.reply-box,\n.edit-comment-box {\n  gap: 7px;\n  margin-top: 9px;\n  padding: 9px;\n  border: 1px solid #dbe7ed;\n  border-radius: 10px;\n  background: #f7fafb;\n}\n\n.reply-box input,\n.edit-comment-box input {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 9px 10px;\n  border: 1px solid #d3e0e7;\n  border-radius: 9px;\n  color: #29475e;\n  background: #ffffff;\n  font-size: .74rem;\n}\n\n.reply-box input:focus,\n.edit-comment-box input:focus { outline: 0; border-color: #e95a13; box-shadow: 0 0 0 3px rgba(233, 90, 19, .09); }\n\n.reply-actions,\n.edit-actions { gap: 6px; margin-top: 0; }\n\n.reply-actions button,\n.edit-actions button {\n  padding: 6px 9px;\n  border-radius: 8px;\n  font-size: .64rem;\n  font-weight: 800;\n}\n\n.reply-actions button:first-child,\n.edit-actions button:first-child { border: 1px solid #dbe6ec; color: #4e7799; background: #f2f6f8; }\n.reply-actions button:last-child,\n.edit-actions button:last-child { border: 1px solid #e95a13; color: #ffffff; background: #e95a13; box-shadow: none; }\n.reply-actions button:last-child:hover,\n.edit-actions button:last-child:hover { background: #d84f0d; box-shadow: none; transform: none; }\n\n.show-more-replies,\n.hide-replies { color: #e95a13; font-size: .65rem; font-weight: 800; }\n.show-more-replies:hover,\n.hide-replies:hover { text-decoration: none; transform: none; }\n\n.comment-input {\n  gap: 8px;\n  padding: 11px;\n  border-top: 1px solid #e1ebf0;\n  background: #ffffff;\n}\n\n.comment-input input {\n  min-width: 0;\n  padding: 10px 11px;\n  border: 1px solid #d7e3e9;\n  border-radius: 10px;\n  color: #29475e;\n  background: #f3f7f9;\n  font-size: .76rem;\n}\n\n.comment-input input:focus { border-color: #e95a13; background: #ffffff; box-shadow: 0 0 0 3px rgba(233, 90, 19, .09); }\n\n.comment-input button {\n  padding: 9px 12px;\n  border: 1px solid #e95a13;\n  border-radius: 10px;\n  color: #ffffff;\n  background: #e95a13;\n  font-size: .7rem;\n  font-weight: 850;\n  cursor: pointer;\n}\n\n.comment-input button:hover { background: #d84f0d; }\n.no-comments { margin: 20px 4px; color: #71899b; font-size: .78rem; text-align: center; }\n\n@media (max-width: 768px) {\n  .comment-list { padding: 8px; }\n  .comment-item { gap: 6px; padding: 9px 1px; }\n  .comment-top b, .reply-content b { max-width: 125px; font-size: .72rem; }\n  .comment-left > p, .reply-item > p { font-size: .74rem; line-height: 1.45; }\n  .comment-bottom-actions button, .reply-actions-row button { font-size: .61rem; }\n  .comment-input { padding: 9px; }\n  .comment-input input { padding: 9px; font-size: .72rem; }\n  .comment-input button { padding: 9px 10px; font-size: .66rem; }\n  .replies-container { padding-left: 8px; }\n  .reply-item { padding: 7px 29px 7px 8px; }\n}\n\n/* Feed comment panel: anchor to the reading column, not the page center. */\n.feed-canvas .comment-overlay {\n  position: fixed;\n  inset: auto auto 0 50%;\n  width: min(680px, calc(100vw - 28px));\n  height: auto;\n  margin: 0;\n  transform: translateX(-50%);\n  display: block;\n  z-index: 9999;\n}\n\n.feed-canvas .comment-panel {\n  width: 100%;\n  height: min(60svh, 560px);\n  max-height: 60svh;\n  overflow: hidden;\n  border: 1px solid rgba(148, 169, 186, .38);\n  border-bottom: 0;\n  border-radius: 18px 18px 0 0;\n  box-shadow: 0 24px 60px rgba(12, 31, 47, .22), inset 0 1px #ffffff;\n  animation: comment-panel-in .28s cubic-bezier(.2, .8, .2, 1);\n}\n\n@keyframes comment-panel-in {\n  from { opacity: 0; transform: translateY(100%); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (min-width: 1150px) {\n  .feed-canvas .comment-overlay {\n    left: calc(50% - 70px);\n  }\n}\n\n@media (max-width: 768px) {\n  .feed-canvas .comment-overlay {\n    width: 100%;\n  }\n\n  .feed-canvas .comment-panel {\n    height: 60svh;\n    max-height: 60svh;\n    border-radius: 18px 18px 0 0;\n  }\n}\n.native-feed-welcome,\n.native-pull-refresh {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
